import type { MessageKey } from "./en";

/** Bangla messages. Type-checked to cover every English key. */
export const bn: Record<MessageKey, string> = {
  "common.appName": "BrandEx",
  "common.loading": "লোড হচ্ছে…",
  "common.save": "সংরক্ষণ",
  "common.cancel": "বাতিল",
  "common.retry": "আবার চেষ্টা করুন",
  "common.signOut": "সাইন আউট",
  "staffAccount.title": "এটি একটি BrandEx স্টাফ অ্যাকাউন্ট",
  "staffAccount.body": "স্টাফরা BrandEx অ্যাডমিন প্যানেলে কাজ করেন, সেখানে আপনার দায়িত্বে থাকা ক্লায়েন্টদের দেখতে পাবেন। একই ইমেইল, পাসওয়ার্ড ও অথেনটিকেটর অ্যাপ দিয়ে সেখানে সাইন ইন করুন।",
  "staffAccount.open": "অ্যাডমিন প্যানেল খুলুন",
  "common.refresh": "রিফ্রেশ",
  "common.error": "কিছু ভুল হয়েছে। আবার চেষ্টা করুন।",
  "common.language": "ভাষা",

  "auth.signIn": "সাইন ইন",
  "auth.signUp": "ফ্রি অ্যাকাউন্ট খুলুন",
  "auth.email": "ইমেইল",
  "auth.password": "পাসওয়ার্ড",
  "auth.passwordHint": "কমপক্ষে ১২ অক্ষর। একটি ছোট বাক্য ভালো কাজ করে।",
  "auth.displayName": "আপনার নাম",
  "auth.organizationName": "চেম্বার বা ক্লিনিকের নাম (ঐচ্ছিক)",
  "auth.totpCode": "অথেনটিকেটর কোড",
  "auth.forgotPassword": "পাসওয়ার্ড ভুলে গেছেন?",
  "auth.noAccount": "BrandEx-এ নতুন?",
  "auth.haveAccount": "আগে থেকেই অ্যাকাউন্ট আছে?",
  "auth.freeForever": "ফ্রি সফটওয়্যার। কোনো সাবস্ক্রিপশন বা কার্ড লাগবে না।",
  "auth.resetTitle": "পাসওয়ার্ড রিসেট করুন",
  "auth.resetSent": "এই ইমেইলে অ্যাকাউন্ট থাকলে একটি রিসেট লিংক পাঠানো হয়েছে।",
  "auth.sendResetLink": "রিসেট লিংক পাঠান",
  "auth.newPassword": "নতুন পাসওয়ার্ড",
  "auth.setPassword": "নতুন পাসওয়ার্ড সেট করুন",
  "auth.passwordUpdated": "পাসওয়ার্ড আপডেট হয়েছে। সাইন ইন করুন।",
  "auth.verifying": "আপনার ইমেইল যাচাই করা হচ্ছে…",
  "auth.verified": "ইমেইল যাচাই সম্পন্ন হয়েছে।",
  "auth.verifyFailed": "লিংকটি অবৈধ বা মেয়াদোত্তীর্ণ।",
  "auth.registered": "অ্যাকাউন্ট তৈরি হয়েছে। ইমেইল যাচাই করতে ইনবক্স দেখুন।",

  "error.unauthenticated": "ইমেইল বা পাসওয়ার্ড সঠিক নয়।",
  "error.mfa_required": "অথেনটিকেটর অ্যাপের কোডটি দিন।",
  "error.rate_limited": "অনেকবার চেষ্টা হয়েছে। {seconds} সেকেন্ড অপেক্ষা করুন।",
  "error.email_taken": "এই ইমেইলে আগে থেকেই একটি অ্যাকাউন্ট আছে।",
  "error.validation_failed": "চিহ্নিত ঘরটি যাচাই করুন।",
  "error.network": "BrandEx-এ সংযোগ করা যাচ্ছে না। ইন্টারনেট সংযোগ দেখুন।",
  "error.article_pins_full": "তিনটি প্রবন্ধ ইতিমধ্যে পিন করা। আগে একটির পিন সরান।",
  "error.social_pins_full": "এই প্ল্যাটফর্মে ইতিমধ্যে তিনটি পোস্ট পিন করা। আগে একটির পিন সরান।",

  "nav.overview": "সারসংক্ষেপ",
  "nav.profile": "প্রোফাইল",
  "nav.inbox": "ইনবক্স",
  "nav.services": "সার্ভিস",
  "nav.team": "টিম",
  "nav.security": "নিরাপত্তা",
  "nav.month": "আপনার মাস",
  "nav.research": "গবেষণা",
  "nav.schedule": "সময়সূচি",
  "nav.studio": "স্টুডিও",
  "nav.approvals": "অনুমোদন",
  "nav.ads": "বিজ্ঞাপন",
  "nav.google": "গুগল",
  "nav.bookings": "বুকিং",
  "nav.report": "রিপোর্ট",
  "nav.ethics": "নৈতিকতা",
  "nav.settings": "সেটিংস",
  "nav.package": "প্যাকেজ ও বিলিং",
  "package.title": "প্যাকেজ ও বিলিং",
  "package.current": "বর্তমান প্যাকেজ",
  "package.perMonth": "/ মাস",
  "package.toQuote": "মূল্য BrandEx নির্ধারণ করবে",
  "package.included": "অন্তর্ভুক্ত",
  "package.status.requested": "অনুরোধ করা হয়েছে — BrandEx পরিধি ও মূল্য নিশ্চিত করবে",
  "package.status.quoted": "মূল্য নির্ধারিত — BrandEx নিশ্চিত করতে যোগাযোগ করবে",
  "package.status.active": "সক্রিয়",
  "package.status.paused": "স্থগিত",
  "package.status.cancelled": "বাতিল",
  "package.none": "আপনার এখনো কোনো প্যাকেজ নেই। স্ট্যান্ডার্ড প্যাকেজ বেছে নিন বা কাস্টম প্যাকেজ চান।",
  "package.marketValue": "অন্তর্ভুক্ত কাজের বাজারমূল্য: {value}",
  "package.choose": "এই প্যাকেজ চান",
  "package.custom": "কাস্টম প্যাকেজ",
  "package.customHint": "যেকোনো অংশ বাড়ান বা কমান। জমা দেওয়ার পর টিম একটি কোটেশন তৈরি করবে।",
  "package.customNote": "আর কিছু জানাতে চান?",
  "package.requestCustom": "কাস্টম কোটেশন চান",
  "package.requested": "অনুরোধ পাঠানো হয়েছে। BrandEx পরিধি ও মূল্য নিশ্চিত করবে।",
  "package.askChange": "পরিবর্তনের অনুরোধ",
  "package.askChangeLabel": "কী যোগ বা কমাতে চান?",
  "package.send": "BrandEx-কে পাঠান",
  "package.changeSent": "পাঠানো হয়েছে। টিম আপনার সাথে যোগাযোগ করবে।",
  "package.previousRequests": "আপনার অনুরোধসমূহ",
  "package.paymentNote": "পেমেন্ট BrandEx টিম রেকর্ড করে। অনলাইন পেমেন্ট পরে আসছে।",
  "nav.workspace": "ওয়ার্কস্পেস",
  "greeting.morning": "শুভ সকাল, {name}",
  "greeting.afternoon": "শুভ অপরাহ্ন, {name}",
  "greeting.evening": "শুভ সন্ধ্যা, {name}",
  "comingSoon.research": "আপনার এলাকার রোগীরা কী খুঁজছেন ও জিজ্ঞেস করছেন তা দেখুন, যাতে প্রতিটি কনটেন্ট একটি বাস্তব প্রশ্নের উত্তর দেয়।",
  "comingSoon.studio": "স্টুডিও সেশন বুক করুন এবং রেকর্ডিং থেকে চূড়ান্ত এডিট পর্যন্ত অনুসরণ করুন।",
  "comingSoon.approvals": "BrandEx টিমের ড্রাফট দেখুন, অনুমোদন দিন বা পরিবর্তন চান — আপনার অনুমতি ছাড়া কিছুই প্রকাশ হয় না।",
  "comingSoon.ads": "আলাদা চুক্তিতে আমাদের টিম পরিচালিত ক্যাম্পেইন, খরচের সীমা ও চালুর আগে আপনার অনুমোদনসহ।",
  "comingSoon.google": "গুগল বিজনেস প্রোফাইল সেটআপ ও সঠিক রাখুন, রিভিউ এক জায়গায়।",
  "comingSoon.bookings": "রোগীরা আপনাকে খুঁজে অনলাইনে অ্যাপয়েন্টমেন্ট বুক করতে পারবেন।",
  "comingSoon.ethics": "কিছু প্রকাশের আগে চিকিৎসা বিজ্ঞাপনের নিয়ম ও রোগীর গোপনীয়তা যাচাই।",

  "overview.welcome": "স্বাগতম, {name}",
  "overview.completeness": "প্রোফাইল সম্পূর্ণতা",
  "overview.nextSteps": "পরবর্তী করণীয়",
  "overview.step.verifyEmail": "ইমেইল ঠিকানা যাচাই করুন",
  "overview.step.addPhone": "ফোন নম্বর যোগ করুন",
  "overview.step.enableMfa": "টু-ফ্যাক্টর অথেনটিকেশন চালু করুন",
  "overview.step.inviteTeam": "একজন সহকর্মীকে আমন্ত্রণ জানান",
  "overview.resendVerification": "যাচাই ইমেইল আবার পাঠান",
  "overview.verificationSent": "যাচাই ইমেইল পাঠানো হয়েছে।",
  "overview.metricsNote": "এই হিসাব BrandEx আপনার অ্যাকাউন্টের তথ্য থেকে করেছে।",
  "dash.awaiting": "আপনার অনুমোদনের অপেক্ষায়",
  "dash.bookings": "নতুন বুকিং অনুরোধ",
  "dash.published": "এই মাসে প্রকাশিত",
  "dash.attention": "আপনার মনোযোগ প্রয়োজন",
  "dash.nothing": "এই মুহূর্তে আপনার কিছু করার নেই।",
  "dash.approve": "অনুমোদন",
  "dash.review": "দেখুন",
  "dash.confirm": "নিশ্চিত করুন",
  "dash.decline": "বাতিল",
  "dash.more": "আরও {n}টি",
  "dash.portfolio": "আপনার পোর্টফোলিও",
  "dash.finishProfile": "প্রোফাইল সম্পূর্ণ করুন",
  "dash.finishProfileHint": "ওয়েবসাইট ও কনটেন্ট পরিকল্পনা পেতে প্রোফাইল, চেম্বার ও প্যাকেজ সেট করুন।",
  "dash.editProfile": "প্রোফাইল সম্পাদনা",
  "dash.nextShoot": "পরবর্তী শুট",
  "dash.noShoot": "এখনো কোনো শুট নির্ধারিত হয়নি।",
  "dash.fullSchedule": "পুরো সময়সূচি",
  "dash.studio": "BrandEx স্টুডিও",
  "dash.package": "এই মাসের প্যাকেজ",
  "dash.packageHint": "আপনার প্যাকেজের মধ্যে অনুমোদিত বা প্রকাশিত কাজ।",
  "dash.noPackage": "BrandEx আপনার মাস পরিকল্পনা করলে অগ্রগতি দেখা যাবে।",
  "dash.withYou": "{n}টি আপনার অপেক্ষায়",
  "overview.organization": "প্রতিষ্ঠান",
  "overview.role": "আপনার ভূমিকা",

  "comingSoon.title": "পরবর্তী রিলিজে আসছে",
  "comingSoon.inbox": "ইউনিফায়েড ইনবক্সে ওয়েবসাইট চ্যাট, হোয়াটসঅ্যাপ, মেসেঞ্জার, ইনস্টাগ্রাম ও টেলিগ্রাম এক জায়গায় থাকবে।",
  "comingSoon.services": "ম্যানেজড সার্ভিস প্যাকেজ দেখুন এবং BrandEx টিমের সাথে প্রজেক্ট ট্র্যাক করুন।",
  "comingSoon.profile": "আপনার পাবলিক প্রফেশনাল প্রোফাইল তৈরি করুন এবং সোশ্যাল অ্যাকাউন্ট যুক্ত করুন।",

  "security.sessions": "সাইন-ইন করা ডিভাইস",
  "security.thisDevice": "এই ডিভাইস",
  "security.signOutDevice": "সাইন আউট",
  "security.signOutAll": "সব ডিভাইস থেকে সাইন আউট",
  "security.changePassword": "পাসওয়ার্ড পরিবর্তন",
  "security.currentPassword": "বর্তমান পাসওয়ার্ড",
  "security.passwordChanged": "পাসওয়ার্ড পরিবর্তন হয়েছে। অন্যান্য ডিভাইস থেকে সাইন আউট করা হয়েছে।",
  "security.mfa": "টু-ফ্যাক্টর অথেনটিকেশন",
  "security.mfaOn": "চালু — অথেনটিকেটর অ্যাপ দিয়ে আপনার অ্যাকাউন্ট সুরক্ষিত।",
  "security.mfaOff": "বন্ধ",
  "security.mfaStart": "অথেনটিকেটর অ্যাপ সেট আপ করুন",
  "security.mfaScan": "অথেনটিকেটর অ্যাপ (Google Authenticator, Microsoft Authenticator, 1Password…) দিয়ে QR কোড স্ক্যান করুন অথবা সেটআপ কী লিখুন, তারপর অ্যাপে দেখানো ৬ অঙ্কের কোড দিন।",
  "security.mfaQr": "অথেনটিকেটর অ্যাপের জন্য QR কোড",
  "security.mfaKeyHint": "সময়-ভিত্তিক (time-based) কী বেছে নিন। নিশ্চিত না করা পর্যন্ত এই কী একই থাকবে, অন্য পাতায় গেলেও — তবে পেজ রিলোড করলে নতুন কী তৈরি হয়, তাই একবারেই স্ক্যান করুন।",
  "security.mfaKey": "সেটআপ কী",
  "security.mfaConfirm": "নিশ্চিত করুন",
  "security.mfaCodeRejected": "এই কোডটি স্ক্রিনে দেখানো সেটআপ কী-এর সাথে মিলছে না। আপনার অথেনটিকেটরে আগেই Brandex যোগ করা থাকলে সেগুলো মুছে ফেলে আবার এই QR স্ক্যান করুন। ফোনের তারিখ ও সময় স্বয়ংক্রিয়ভাবে সেট থাকা নিশ্চিত করুন।",
  "security.mfaEnabled": "টু-ফ্যাক্টর অথেনটিকেশন চালু হয়েছে।",
  "security.lastActive": "সর্বশেষ সক্রিয় {time}",

  "team.members": "সদস্য",
  "team.role": "ভূমিকা",
  "team.joined": "যোগদান",
  "team.roleUpdated": "ভূমিকা আপডেট হয়েছে।",
  "role.owner": "মালিক",
  "role.admin": "অ্যাডমিন",
  "role.manager": "ম্যানেজার",
  "role.agent": "এজেন্ট",
  "role.viewer": "দর্শক",
  "role.assistant": "সহকারী",

  "onboarding.title": "আপনার BrandEx প্রোফাইল তৈরি করুন",
  "onboarding.step": "ধাপ {n} / {total}",
  "onboarding.savedLocally": "শেষ না করা পর্যন্ত আপনার অগ্রগতি এই ডিভাইসে সংরক্ষিত থাকে।",
  "onboarding.steps.account": "আপনার অ্যাকাউন্ট",
  "onboarding.steps.practice": "প্র্যাকটিস",
  "onboarding.steps.qualifications": "যোগ্যতা",
  "onboarding.steps.chambers": "চেম্বার ও বুকিং",
  "onboarding.steps.package": "প্যাকেজ",
  "onboarding.steps.brand": "কনটেন্ট ও ব্র্যান্ড",
  "onboarding.fullName": "পূর্ণ নাম",
  "onboarding.fullNameHint": "রোগীরা যেভাবে দেখবেন, যেমন ডা. আয়েশা রহমান।",
  "onboarding.phone": "মোবাইল নম্বর",
  "onboarding.phoneHint": "যেমন 01712-345678। বুকিংয়ের নোটিফিকেশনের জন্য।",
  "onboarding.specialty": "বিশেষজ্ঞতা",
  "onboarding.designation": "পদবি ও কর্মস্থল",
  "onboarding.designationHint": "যেমন কনসালট্যান্ট, স্যাম্পল হাসপাতাল",
  "onboarding.registration": "মেডিকেল কাউন্সিল রেজিস্ট্রেশন নং (ঐচ্ছিক)",
  "onboarding.registrationHint": "এখন ঐচ্ছিক, তবে ওয়েবসাইট প্রকাশে লাগবে: BrandEx এটি বিএমডিসি রেজিস্টারে যাচাই করে।",
  "onboarding.languages": "যে ভাষায় পরামর্শ দেন",
  "onboarding.degrees": "ডিগ্রি",
  "onboarding.degreeTitle": "ডিগ্রি {n}",
  "onboarding.degreeInstitution": "প্রতিষ্ঠান (ঐচ্ছিক)",
  "onboarding.degreeYear": "সাল (ঐচ্ছিক)",
  "onboarding.addDegree": "ডিগ্রি যোগ করুন",
  "onboarding.removeDegree": "ডিগ্রি {n} সরান",
  "onboarding.bio": "আপনার সম্পর্কে, দুই-তিন লাইনে",
  "onboarding.bioHint": "{count} অক্ষর। ২০ থেকে ৬০০; ভালো পরিচিতি ১৫০ থেকে ৪০০।",
  "onboarding.chamber": "চেম্বার {n}",
  "onboarding.chamberName": "নাম",
  "onboarding.chamberAddress": "ঠিকানা",
  "onboarding.days": "দিন",
  "onboarding.from": "শুরু",
  "onboarding.to": "শেষ",
  "onboarding.minutes": "প্রতি রোগীর জন্য মিনিট",
  "onboarding.minutesValue": "{n} মিনিট",
  "onboarding.addChamber": "আরেকটি চেম্বার যোগ করুন",
  "onboarding.removeChamber": "চেম্বার {n} সরান",
  "onboarding.location": "ম্যাপে অবস্থান (ঐচ্ছিক)",
  "onboarding.location.hint": "চেম্বারের Google Maps লিংক পেস্ট করুন বা স্থানাঙ্ক লিখুন। রোগীরা নিজের জায়গা থেকে পথনির্দেশ পাবেন।",
  "onboarding.location.set": "ম্যাপে {lat}, {lng}।",
  "onboarding.location.placeholder": "https://www.google.com/maps/place/… অথবা 23.7808, 90.4073",
  "onboarding.location.here": "আমি চেম্বারে আছি: আমার অবস্থান নিন",
  "onboarding.location.find": "Google Maps-এ খুঁজুন",
  "onboarding.location.check": "ম্যাপে দেখে নিন",
  "onboarding.location.clear": "সরান",
  "onboarding.location.denied": "অবস্থান জানার অনুমতি বন্ধ আছে। ব্রাউজারে অনুমতি দিন, অথবা Google Maps লিংক পেস্ট করুন।",
  "onboarding.location.unavailable": "এই ডিভাইস অবস্থান খুঁজে পায়নি। Google Maps লিংক পেস্ট করুন।",
  "onboarding.error.location": "চেম্বারের Google Maps লিংক বা 23.7808, 90.4073 এর মতো স্থানাঙ্ক দিন।",
  "onboarding.error.shortLink": "ছোট লিংক পড়া যায় না। লিংকটি খুলে ব্রাউজারের ঠিকানা বার থেকে পুরো ঠিকানা কপি করুন।",
  "onboarding.autoConfirm": "স্লট খালি থাকলে অ্যাপয়েন্টমেন্ট স্বয়ংক্রিয়ভাবে নিশ্চিত করুন",
  "onboarding.packageIntro": "BrandEx টিমের তৈরি একটি প্যাকেজ বেছে নিন, অথবা কাস্টম কোটেশন চান।",
  "onboarding.includesWebsite": "আপনার ডাক্তার ওয়েবসাইট অন্তর্ভুক্ত",
  "onboarding.noWebsite": "ওয়েবসাইট নেই",
  "onboarding.addOn": "যোগ করুন: {name}",
  "onboarding.selected": "নির্বাচিত",
  "onboarding.select": "বেছে নিন",
  "onboarding.noPlans": "এই মুহূর্তে কোনো প্যাকেজ নেই। নিচে কাস্টম কোটেশন চান।",
  "onboarding.accent": "পোর্টফোলিওর অ্যাকসেন্ট রং",
  "onboarding.shootType": "পছন্দের শুটের ধরন",
  "onboarding.back": "পেছনে",
  "onboarding.continue": "এগিয়ে যান",
  "onboarding.createAccount": "অ্যাকাউন্ট তৈরি করে এগিয়ে যান",
  "onboarding.build": "আমার প্রোফাইল তৈরি করুন",
  "onboarding.signInInstead": "আগে নিবন্ধন করেছেন? সাইন ইন করুন",
  "onboarding.error.required": "এই ঘরটি পূরণ করুন।",
  "onboarding.error.bio": "২০ থেকে ৬০০ অক্ষরের মধ্যে লিখুন।",
  "onboarding.error.days": "অন্তত একটি দিন বেছে নিন।",
  "onboarding.error.hours": "শেষের সময়ে অন্তত একজন রোগী দেখার সময় রাখুন।",
  "onboarding.error.languages": "অন্তত একটি ভাষা বেছে নিন।",
  "onboarding.error.package": "একটি প্যাকেজ বেছে নিন বা কাস্টম কোটেশন চান।",
  "onboarding.error.custom": "কাস্টম প্যাকেজে অন্তত একটি আইটেম রাখুন।",
  "onboarding.error.phone": "01712-345678 বা +8801712345678 এর মতো মোবাইল নম্বর দিন।",
  "onboarding.error.email": "সঠিক ইমেইল ঠিকানা দিন।",
  "onboarding.error.year": "১৯৫০ থেকে আগামী বছরের মধ্যে চার অঙ্কের সাল দিন।",
  "onboarding.error.server": "এই ঘরটি ঠিক করুন।",
  "onboarding.error.serverDetail": "চিহ্নিত ঘরটি ঠিক করুন: {detail}।",
  "onboarding.done.title": "সব প্রস্তুত",
  "onboarding.done.subtitle": "BrandEx আপনার জন্য যা তৈরি করেছে।",
  "onboarding.done.account": "{email} এর জন্য অ্যাকাউন্ট তৈরি হয়েছে",
  "onboarding.done.verify": "ইমেইল যাচাই করতে আপনার ইনবক্স দেখুন।",
  "onboarding.done.profile": "প্রোফাইল: {name} · {specialty}",
  "onboarding.done.chambers": "সাপ্তাহিক সময়সহ চেম্বার: {count}",
  "onboarding.done.autoConfirm": "খালি স্লট স্বয়ংক্রিয়ভাবে নিশ্চিত হবে",
  "onboarding.done.manualConfirm": "প্রতিটি অ্যাপয়েন্টমেন্ট আপনি নিজে নিশ্চিত করবেন",
  "onboarding.done.package": "অনুরোধ করা প্যাকেজ: {name}",
  "onboarding.done.packageCustom": "কাস্টম প্যাকেজের অনুরোধ পাঠানো হয়েছে। BrandEx কোটেশন পাঠাবে।",
  "onboarding.done.brand": "অ্যাকসেন্ট রং ও পছন্দের শুটের ধরন সংরক্ষিত",
  "onboarding.done.go": "আমার ড্যাশবোর্ডে যান",
  "specialty.gynaecology_obstetrics": "গাইনি ও প্রসূতি",
  "specialty.paediatrics": "শিশুরোগ",
  "specialty.medicine": "মেডিসিন",
  "specialty.cardiology": "হৃদরোগ",
  "specialty.dermatology": "চর্মরোগ",
  "specialty.orthopaedics": "অর্থোপেডিক্স",
  "specialty.other": "অন্যান্য",
  "language.bangla": "বাংলা",
  "language.english": "ইংরেজি",
  "language.hindi": "হিন্দি",
  "language.arabic": "আরবি",
  "day.sat": "শনি",
  "day.sun": "রবি",
  "day.mon": "সোম",
  "day.tue": "মঙ্গল",
  "day.wed": "বুধ",
  "day.thu": "বৃহঃ",
  "day.fri": "শুক্র",
  "accent.azure": "আকাশি",
  "accent.indigo": "নীল",
  "accent.teal": "টিল",
  "accent.emerald": "পান্না",
  "accent.violet": "বেগুনি",
  "accent.rose": "গোলাপি",
  "accent.amber": "অ্যাম্বার",
  "accent.slate": "স্লেট",
  "shoot.in_studio": "স্টুডিওতে",
  "shoot.in_person": "সরাসরি (আমার চেম্বারে)",
  "shoot.podcast": "পডকাস্ট",
  "error.phone_taken": "এই মোবাইল নম্বরটি আগেই নিবন্ধিত।",
  "nav.website": "আমার ওয়েবসাইট",
  "nav.visitors": "ওয়েবসাইট ভিজিটর",
  "website.title": "আমার ওয়েবসাইট",
  "website.view": "আমার সাইট দেখুন",
  "website.state.awaiting_verification": "বিএমডিসি রেজিস্ট্রেশন যাচাইয়ের অপেক্ষায়",
  "verification.notSubmitted": "ওয়েবসাইট প্রকাশ করতে আপনার বিএমডিসি রেজিস্ট্রেশন নম্বর যোগ করুন।",
  "verification.pending": "BrandEx বিএমডিসি রেজিস্ট্রেশন {number} যাচাই করছে। যাচাই হলে আপনার ওয়েবসাইট চালু হবে।",
  "verification.rejected": "আপনার বিএমডিসি রেজিস্ট্রেশন যাচাই করা যায়নি: {reason}। অনুগ্রহ করে নম্বরটি দেখুন।",
  "verification.verified": "বিএমডিসি রেজিস্ট্রেশন {number} যাচাই করা হয়েছে।",
  "verification.fix": "রেজিস্ট্রেশন নম্বর হালনাগাদ করুন",
  "notify.registration_verified": "আপনার বিএমডিসি রেজিস্ট্রেশন যাচাই হয়েছে। আপনার ওয়েবসাইট চালু হতে পারে।",
  "notify.registration_rejected": "আপনার বিএমডিসি রেজিস্ট্রেশন যাচাই করা যায়নি: {reason}",
  "notify.article_submitted": "{author} আপনার রিভিউয়ের জন্য একটি লেখা পাঠিয়েছেন: {title}",
  "notify.article_submitted_plain": "একটি লেখা আপনার রিভিউয়ের অপেক্ষায়: {title}",
  "notify.article_changes_requested": "ডাক্তার আপনার লেখায় পরিবর্তন চেয়েছেন: {title}",
  "notify.article_published": "আপনার লেখাটি ডাক্তারের ওয়েবসাইটে প্রকাশিত হয়েছে: {title}",
  "portfolio.verified": "বিএমডিসি রেজিস্ট্রেশন যাচাইকৃত",
  "website.state.live": "চালু",
  "website.state.awaiting_activation": "সংরক্ষিত — প্যাকেজ চালু হলে প্রকাশিত হবে",
  "website.state.not_included": "আপনার প্যাকেজে অন্তর্ভুক্ত নয়",
  "website.state.offline": "বন্ধ",
  "website.state.needs_onboarding": "সাইট তৈরি করতে অনবোর্ডিং শেষ করুন",
  "package.payment": "পেমেন্ট",
  "package.noInvoices": "এখনো কোনো ইনভয়েস নেই। BrandEx প্রতি মাসে আপনার প্যাকেজের বিল করে।",
  "package.status": "অবস্থা",
  "package.dueOn": "শেষ তারিখ {date}",
  "package.month": "মাস",
  "package.amount": "পরিমাণ",
  "package.paidOn": "পরিশোধ",
  "package.invoice.due": "বকেয়া",
  "package.invoice.paid": "পরিশোধিত",
  "package.invoice.overdue": "মেয়াদোত্তীর্ণ",
  "package.invoice.void": "বাতিল",
  "package.method.bank_transfer": "ব্যাংক ট্রান্সফার",
  "package.method.bkash": "বিকাশ",
  "package.method.nagad": "নগদ",
  "package.method.cash": "নগদ টাকা",
  "package.method.card": "কার্ড",
  "package.prepaid": "{months} মাস অগ্রিম · সাশ্রয় {discount}",
  "package.refunded": "ফেরত {amount}",
  "package.prepayOffer": "৬ মাস অগ্রিম দিলে ৫%, ১২ মাস দিলে ১০% সাশ্রয়। অগ্রিম ইনভয়েসের জন্য BrandEx-কে বলুন।",
  "package.cancel.title": "প্যাকেজ বাতিল করুন",
  "package.cancel.hint": "যেকোনো সময় বাতিল করতে পারেন। প্যাকেজ এই মাসের শেষ পর্যন্ত চলবে, এরপর আর বিল হবে না। ততদিন আপনার ওয়েবসাইট অনলাইনে থাকবে।",
  "package.cancel.start": "প্যাকেজ বাতিল করুন",
  "package.cancel.confirm": "এই মাসের শেষে বাতিল করবেন? অব্যবহৃত অগ্রিম মাসের টাকা ছাড় বাদে ফেরত দেওয়া হবে।",
  "package.cancel.yes": "হ্যাঁ, মাস শেষে বাতিল করুন",
  "package.cancel.no": "প্যাকেজ রাখুন",
  "package.cancel.ending": "আপনার প্যাকেজ {date}-এর পর শেষ হবে। এরপর আর বিল হবে না।",
  "package.cancel.keep": "প্যাকেজ রাখুন",
  "package.cancel.withdrawTitle": "অনুরোধ ফিরিয়ে নিন",
  "package.cancel.withdrawHint": "এখনো কোনো বিল হয়নি।",
  "package.cancel.withdraw": "অনুরোধ ফিরিয়ে নিন",
  "package.cancel.withdrawConfirm": "এই প্যাকেজের অনুরোধ ফিরিয়ে নেবেন?",
  "package.cancel.withdrawYes": "হ্যাঁ, ফিরিয়ে নিন",
  "package.quoteValidUntil": "এই কোটেশন {date} পর্যন্ত বৈধ।",
  "package.quoteExpired": "এই কোটেশনের মেয়াদ {date} তারিখে শেষ হয়েছে। BrandEx আপনাকে নতুন কোটেশন পাঠাবে।",
  "package.priceLockedUntil": "আপনার মূল্য {date} পর্যন্ত নির্দিষ্ট থাকবে।",
  "package.method.other": "অন্যান্য",
  "notify.payment_due": "{period}-এর ইনভয়েস তৈরি: {amount}, শেষ তারিখ {due_on}",
  "notify.payment_overdue": "{period}-এর পেমেন্ট মেয়াদোত্তীর্ণ: {amount}",
  "notify.payment_received": "{period}-এর পেমেন্ট পাওয়া গেছে: {amount}। ধন্যবাদ।",
  "notify.payment_late": "{doctor}-এর {period}-এর ইনভয়েস ({amount}) {days} দিন বকেয়া",
  "notify.refund_issued": "BrandEx {period}-এর জন্য {amount} ফেরত দিয়েছে। ১০ কর্মদিবসের মধ্যে আপনার আগের পেমেন্ট মাধ্যমে পৌঁছাবে।",
  "notify.package_cancelled": "একটি প্র্যাকটিস প্যাকেজ বাতিল করেছে",
  "notify.package_cancelled_until": "একটি প্র্যাকটিস প্যাকেজ বাতিল করেছে; {ends_at} পর্যন্ত চলবে",
  "notify.package_kept": "একটি প্র্যাকটিস বাতিলের অনুরোধ ফিরিয়ে নিয়েছে",
  "notify.monthly_report_ready": "{month} মাসের রিপোর্ট প্রস্তুত",
  "report.title": "মাসিক রিপোর্ট",
  "report.intro": "এই মাসে BrandEx আপনার জন্য যা করেছে, আমাদের নিজস্ব রেকর্ড থেকে।",
  "report.prev": "আগের মাস",
  "report.next": "পরের মাস",
  "report.inProgress": "চলমান",
  "report.final": "চূড়ান্ত",
  "report.inProgressHint": "মাসটি এখনো চলছে। কাজ অনুমোদন ও প্রকাশের সাথে সাথে সংখ্যাগুলো হালনাগাদ হয়।",
  "report.finalHint": "মাসের ১ তারিখে বন্ধ হয়েছে। এই রিপোর্ট আর বদলাবে না।",
  "report.calculated": "BrandEx-এর হিসাব",
  "report.summary": "সারসংক্ষেপ",
  "report.approved": "অনুমোদিত কাজ",
  "report.published": "প্রকাশিত পোস্ট",
  "report.appointments": "বুকিং অনুরোধ",
  "report.confirmed": "নিশ্চিত অ্যাপয়েন্টমেন্ট",
  "report.shootsHeld": "সম্পন্ন শুট",
  "report.delivery": "প্যাকেজ বনাম ডেলিভারি",
  "report.kind": "কাজ",
  "report.committed": "প্যাকেজে",
  "report.delivered": "ডেলিভারি",
  "report.publishedCol": "প্রকাশিত",
  "report.waiting": "আপনার কাছে",
  "report.shortfall.awaiting_doctor": "আপনার অনুমোদনের অপেক্ষায়",
  "report.shortfall.in_production": "BrandEx এখনো তৈরি করছে",
  "report.onTrack": "সম্পূর্ণ",
  "report.noDelivery": "এই মাসে কোনো কাজ পরিকল্পনা করা হয়নি।",
  "report.posts": "প্রকাশিত পোস্ট",
  "report.noPosts": "এই মাসে কোনো পোস্ট প্রকাশ হয়নি।",
  "report.bookings": "চেম্বার অনুযায়ী বুকিং",
  "report.bookingsNote": "শুধু সংখ্যা। রোগীর কোনো তথ্য রাখা হয় না।",
  "report.declined": "বাতিল",
  "report.platforms": "প্ল্যাটফর্মের সংখ্যা",
  "report.platformsNote": "রিচ ও ভিউ শুধু সংযুক্ত প্ল্যাটফর্ম থেকে, উৎসসহ দেখানো হয়। আমরা কখনো অনুমান করি না।",
  "report.notConnected": "সংযুক্ত নয়",
  "report.download": "PDF ডাউনলোড",
  "report.followers": "{n} ফলোয়ার",
  "report.views": "{n} ভিউ",
  "report.postsCount": "{n} পোস্ট",
  "report.unavailable": "প্ল্যাটফর্মে পৌঁছানো যায়নি",
  "report.source": "উৎস: {source}, {when}",
  "report.nextMonth": "পরের মাস",
  "report.planned": "{n}টি কাজ আগেই পরিকল্পিত",
  "report.noShoots": "এখনো কোনো শুট নির্ধারিত হয়নি।",
  "notify.bell": "নোটিফিকেশন",
  "notify.bellUnread": "নোটিফিকেশন, {n}টি পড়া হয়নি",
  "notify.title": "নোটিফিকেশন",
  "notify.readAll": "সব পড়া হয়েছে",
  "notify.empty": "নতুন কিছু নেই।",
  "notify.content_sent_to_you": "“{title}” আপনার অনুমোদনের অপেক্ষায়",
  "notify.content_approved": "{doctor} “{title}” অনুমোদন করেছেন",
  "notify.changes_requested": "{doctor} “{title}”-এ পরিবর্তন চেয়েছেন: {comment}",
  "notify.changes_requested_plain": "{doctor} “{title}”-এ পরিবর্তন চেয়েছেন",
  "notify.content_published": "“{title}” {platform}-এ প্রকাশিত হয়েছে",
  "notify.shoot_scheduled": "শুট নির্ধারিত: {shoot}, {when}",
  "notify.shoot_cancelled": "শুট বাতিল: {shoot}, {when}",
  "notify.new_booking": "নতুন বুকিং: {patient}, {when}, {chamber}",
  "notify.booking_cancelled_by_patient": "{patient} {when}, {chamber}-এর বুকিং বাতিল করেছেন",
  "notify.booking_rescheduled": "{patient} বুকিং সরিয়ে {when}, {chamber}-এ নিয়েছেন",
  "notify.template_requested": "{doctor} কাস্টম ওয়েবসাইট টেমপ্লেট চেয়েছেন",
  "notify.template_request_updated.in_progress": "আমাদের ডিজাইন টিম আপনার কাস্টম টেমপ্লেটের কাজ শুরু করেছে",
  "notify.template_request_updated.delivered": "আপনার কাস্টম টেমপ্লেট ব্র্যান্ড কিটে প্রস্তুত",
  "notify.practice_updated_by_staff.profile": "BrandEx আপনার প্রোফাইল ও পোর্টফোলিও হালনাগাদ করেছে",
  "notify.practice_updated_by_staff.brand": "BrandEx আপনার ব্র্যান্ড কিট হালনাগাদ করেছে",
  "notify.practice_updated_by_staff.bookings": "BrandEx আপনার বুকিং সেটিংস হালনাগাদ করেছে",
  "notify.practice_updated_by_staff.website": "BrandEx আপনার ওয়েবসাইট প্রকাশের অবস্থা বদলেছে",
  "notify.social_reconnect_needed": "আপনার {platform} সিঙ্ক হওয়া বন্ধ হয়েছে। ওয়েবসাইট হালনাগাদ রাখতে আবার যুক্ত করুন",
  "notify.template_request_updated.declined": "আপনার কাস্টম টেমপ্লেটের অনুরোধ নেওয়া যায়নি: {note}",
  "bookings.title": "বুকিং",
  "bookings.subtitle": "রোগীরা কীভাবে বুক করেন, কাকে জানানো হয়, এবং আপনার অ্যাপয়েন্টমেন্ট।",
  "bookings.method": "বুকিং পদ্ধতি",
  "bookings.method.built_in": "BrandEx বুকিং (বিল্ট-ইন)",
  "bookings.method.built_in.hint": "রোগীরা আপনার পোর্টফোলিওতে চেম্বার, দিন ও সময় বেছে নেন। প্রতিটি বুকিং BrandEx সার্ভারে স্বয়ংক্রিয়ভাবে সংরক্ষিত হয়।",
  "bookings.method.calendly": "ক্যালেন্ডলি",
  "bookings.method.calendly.hint": "নিজের ক্যালেন্ডলি পেজ ব্যবহার করুন। রোগীরা ক্যালেন্ডলিতে বুক করেন, পোর্টফোলিও সেখানে লিংক করে।",
  "bookings.method.contact": "ফোন বা হোয়াটসঅ্যাপ (প্রস্তাবিত)",
  "bookings.method.contact.hint": "রোগীরা ওয়েবসাইটে বুক চাপলে আপনার নম্বর দেখেন। তারা ফোন বা মেসেজ করেন, আর আপনার চেম্বার সময় ঠিক করে দেয়।",
  "bookings.contactPhone": "রোগীরা যে নম্বরে ফোন করবেন",
  "bookings.contactPhoneHint": "ওয়েবসাইটে দেখানো হবে, যেমন ০১৭১২-৩৪৫৬৭৮।",
  "bookings.contactWhatsapp": "রোগীদের জন্য হোয়াটসঅ্যাপ নম্বর",
  "bookings.contactWhatsappHint": "ওয়েবসাইটে দেখানো হবে। হোয়াটসঅ্যাপে বুকিং না নিলে খালি রাখুন।",
  "bookings.sameNumber": "ফোন নম্বরটিই",
  "bookings.contactNeeded": "বুকিং চালু আছে। ফোন বা হোয়াটসঅ্যাপ নম্বর দিন, যাতে রোগীরা বুক বোতাম থেকে আপনার সাথে যোগাযোগ করতে পারেন।",
  "bookings.publicContact": "আপনার পাবলিক সাইটে বুক বোতাম দেখায়। রোগী বোতামে চাপ দিয়ে ফোন বা হোয়াটসঅ্যাপে যোগাযোগ বেছে নেন।",
  "bookings.calendly": "আপনার ক্যালেন্ডলি লিংক",
  "bookings.whatsapp": "নতুন বুকিংয়ের সতর্কবার্তার হোয়াটসঅ্যাপ",
  "bookings.whatsappHint": "এখন সংরক্ষিত থাকবে। BrandEx হোয়াটসঅ্যাপ যুক্ত করলে বার্তা শুরু হবে।",
  "bookings.email": "নতুন বুকিংয়ের ইমেইল",
  "bookings.emailHint": "প্রতিটি নতুন বুকিং আমরা ইমেইল করি।",
  "bookings.public": "রোগীরা পোর্টফোলিও থেকে বুক করতে পারবেন",
  "bookings.publicHint": "আপনার পাবলিক সাইটে বুক বোতাম দেখায়, যা বুকিং ফর্ম খোলে।",
  "bookings.publicCalendly": "আপনার পাবলিক সাইটে ক্যালেন্ডলি পেজের বোতাম দেখায়।",
  "bookings.autoConfirm": "খালি স্লট স্বয়ংক্রিয়ভাবে নিশ্চিত করুন",
  "bookings.autoConfirmHint": "বন্ধ থাকলে প্রতিটি অনুরোধ আপনি নিশ্চিত বা বাতিল করবেন।",
  "bookings.save": "বুকিং সেটিংস সংরক্ষণ করুন",
  "bookings.saved": "বুকিং সেটিংস সংরক্ষিত হয়েছে।",
  "bookings.appointments": "অ্যাপয়েন্টমেন্ট",
  "bookings.appointmentsHint": "আজ থেকে। রোগীরা আপনার পাবলিক পোর্টফোলিও থেকে বুক করেন।",
  "bookings.none": "আসন্ন কোনো অ্যাপয়েন্টমেন্ট নেই।",
  "bookings.when": "সময়",
  "bookings.patient": "রোগী",
  "bookings.chamber": "চেম্বার",
  "bookings.reason": "কারণ",
  "bookings.status": "অবস্থা",
  "bookings.state.pending": "আপনার অপেক্ষায়",
  "bookings.state.confirmed": "নিশ্চিত",
  "bookings.state.declined": "প্রত্যাখ্যাত",
  "bookings.state.cancelled": "বাতিল",
  "bookings.confirm": "নিশ্চিত করুন",
  "bookings.decline": "প্রত্যাখ্যান",
  "bookings.cancel": "বাতিল",
  "bookings.confirmFor": "{name} নিশ্চিত করুন",
  "bookings.declineFor": "{name} প্রত্যাখ্যান করুন",
  "bookings.cancelFor": "{name} বাতিল করুন",
  "bookings.availability": "সাপ্তাহিক সময়সূচি",
  "bookings.availabilityHint": "স্লট আপনার চেম্বারের দিন ও সময় থেকে আসে। পরিবর্তন করুন",
  "bookings.fee": "কনসালটেশন ফি (৳)",
  "bookings.feeHint": "আপনার পোর্টফোলিওতে দেখানো হবে। লুকাতে খালি রাখুন।",
  "bookings.onlinePayment": "বুকিংয়ের সময় রোগী অনলাইনে ফি দেবেন",
  "bookings.onlinePaymentHint": "পেমেন্টের জন্য সময়টি ৩০ মিনিট ধরে রাখা হয়। পেমেন্ট হলে আপনাকে জানানো হবে।",
  "bookings.onlinePaymentOff": "অনলাইন পেমেন্ট এখনো চালু হয়নি। রোগী চেম্বারে ফি দেবেন।",
  "bookings.onlinePaymentSandbox": "টেস্ট মোড: পেমেন্ট স্যান্ডবক্সে হয়, কোনো টাকা লেনদেন হয় না।",
  "bookings.reference": "রেফ.",
  "bookings.payment.pending": "পেমেন্টের অপেক্ষায়",
  "bookings.payment.paid": "পরিশোধিত {amount}",
  "bookings.payment.failed": "পেমেন্ট ব্যর্থ",
  "bookings.payment.expired": "পেমেন্টের সময় শেষ",
  "bookings.payment.refund_due": "ফেরত {amount}",
  "bookings.cancelledBy.patient": "রোগী বাতিল করেছেন",
  "bookings.cancelledBy.practice": "চেম্বার বাতিল করেছে",
  "bookings.cancelledBy.unpaid": "সময়মতো পেমেন্ট হয়নি",
  "bookings.moved": "{n} বার সরানো",
  "bookings.timeOff": "ছুটি",
  "bookings.timeOffHint": "যেদিন বা যে সময় রোগী দেখবেন না তা বন্ধ রাখুন। সেই সময়গুলো আর দেখানো হবে না।",
  "bookings.timeOff.chamber": "চেম্বার",
  "bookings.timeOff.allChambers": "সব চেম্বার",
  "bookings.timeOff.from": "শুরু",
  "bookings.timeOff.until": "শেষ",
  "bookings.timeOff.note": "নোট (শুধু আপনি দেখবেন)",
  "bookings.timeOff.add": "এই সময় বন্ধ রাখুন",
  "bookings.timeOff.none": "কোনো ছুটি নির্ধারিত নেই।",
  "bookings.timeOff.remove": "সরান",
  "bookings.timeOff.removeFor": "ছুটি সরান {range}",
  "bookings.timeOff.badRange": "শেষ সময় শুরুর পরে হতে হবে।",
  "bookings.timeOff.affected": "এই সময়ে {n}টি বুকিং আছে। সেগুলো বাতিল হয়নি: নিশ্চিত করুন, বাতিল করুন বা রোগীদের ফোন করুন।",
  "nav.content": "কনটেন্ট ও অনুমোদন",
  "content.title": "কনটেন্ট ও অনুমোদন",
  "content.subtitle": "এ মাসে BrandEx আপনার জন্য যা তৈরি করছে। আমরা যা পাঠাই তা দেখুন, অনুমোদন করুন বা পরিবর্তন চান।",
  "content.waiting": "{n}টি আইটেম আপনার অনুমোদনের অপেক্ষায়।",
  "content.filter": "কনটেন্ট ফিল্টার",
  "content.tab.all": "সব",
  "content.tab.in_production": "প্রোডাকশনে",
  "content.month": "মাস",
  "content.allMonths": "সব মাস",
  "content.waitingTitle": "আপনার অনুমোদনের অপেক্ষায়",
  "content.waitingHint": "প্রিভিউ খুলে দেখুন, তারপর অনুমোদন দিন বা টিমকে জানান কী বদলাতে হবে। আপনার অনুমোদন ছাড়া কিছুই প্রকাশ হয় না।",
  "content.allClear": "সব হালনাগাদ: আপনার অনুমোদনের অপেক্ষায় কিছু নেই।",
  "content.allTitle": "আপনার কনটেন্ট",
  "content.noneInTab": "এখানে এখন কিছু নেই।",
  "content.progress": "অগ্রগতি",
  "content.stage.plan": "পরিকল্পিত",
  "content.stage.production": "প্রোডাকশনে",
  "content.stage.review": "আপনার রিভিউ",
  "content.stage.approved": "অনুমোদিত",
  "content.stage.live": "প্রকাশিত",
  "content.count": "{n}টি আইটেম",
  "content.empty": "BrandEx আপনার মাস পরিকল্পনা করলে কনটেন্ট প্ল্যান এখানে দেখা যাবে।",
  "content.footer": "অনুমোদন আপনার নাম ও সময়সহ সংরক্ষিত হয়। আপনার অনুমোদন ছাড়া BrandEx কোনো আইটেম প্রকাশ করতে পারে না।",
  "content.due": "শেষ তারিখ {date}",
  "content.revision": "সংস্করণ {n}",
  "content.caption": "ক্যাপশন",
  "content.preview": "প্রিভিউ দেখুন",
  "content.approve": "অনুমোদন",
  "content.approveItem": "{title} অনুমোদন করুন",
  "content.requestChanges": "পরিবর্তন চান",
  "content.whatToChange": "কী পরিবর্তন করা উচিত?",
  "content.whatToChangeHint": "নির্দিষ্ট করে লিখুন: টিম এই নোট অনুযায়ী কাজ করবে।",
  "content.send": "পাঠান",
  "content.publishedOn": "প্রকাশিত হয়েছে",
  "content.doctorsDiary": "ডক্টরস ডায়েরি",
  "content.yours": "আপনার",
  "content.platform.website": "আপনার ওয়েবসাইট",
  "content.platform.facebook": "ফেসবুক",
  "content.platform.instagram": "ইনস্টাগ্রাম",
  "content.platform.youtube": "ইউটিউব",
  "content.platform.tiktok": "টিকটক",
  "content.platform.linkedin": "লিংকডইন",
  "content.platform.google": "গুগল",
  "content.shoot.next": "পরবর্তী শুট",
  "content.shoot.studio": "BrandEx স্টুডিও",
  "content.shoot.chamber": "আপনার চেম্বার",
  "content.shoot.scheduled": "নির্ধারিত",
  "content.shoot.kind.podcast": "পডকাস্ট",
  "content.shoot.kind.promo_shoot": "প্রোমো শুট",
  "content.shoot.kind.in_person": "সরাসরি শুট",
  "content.shoot.kind.photo_session": "ফটো সেশন",
  "schedule.subtitle": "BrandEx আপনার সাথে যে রেকর্ডিংয়ের দিন ঠিক করেছে এবং কনটেন্ট কবে জমা হবে, বাংলাদেশ সময়ে।",
  "schedule.filter": "দেখান",
  "schedule.filter.all": "সবকিছু",
  "schedule.filter.shoots": "শুট",
  "schedule.filter.content": "কনটেন্ট জমা",
  "schedule.today": "আজ",
  "schedule.minutes": "{n} মিনিট",
  "schedule.due": "{kind} জমার দিন",
  "schedule.empty": "এখনো কিছু নির্ধারিত হয়নি। BrandEx শুট ঠিক করলে এবং কনটেন্টের তারিখ এখানে দেখা যাবে।",
  "content.history": "ইতিহাস",
  "content.by.doctor": "আপনি",
  "content.by.team": "BrandEx",
  "content.by.system": "BrandEx",
  "content.status.planned": "পরিকল্পিত",
  "content.status.shot": "শুট হয়েছে",
  "content.status.editing": "এডিটিং",
  "content.status.internal_review": "অভ্যন্তরীণ রিভিউ",
  "content.status.sent_to_doctor": "আপনার অপেক্ষায়",
  "content.status.changes_requested": "পরিবর্তন চাওয়া হয়েছে",
  "content.status.approved": "অনুমোদিত",
  "content.status.published": "প্রকাশিত",
  "content.kind.podcast": "পডকাস্ট",
  "content.kind.reel": "রিল",
  "content.kind.photo_card": "ফটো কার্ড",
  "content.kind.promo_shoot": "প্রোমো শুট",
  "content.kind.article": "আর্টিকেল",
  "content.kind.website_section": "ওয়েবসাইট অংশ",
  "content.kind.other": "অন্যান্য",
  "nav.brand": "ব্র্যান্ড কিট",
  "brand.title": "ব্র্যান্ড কিট",
  "brand.subtitle": "আপনার পোর্টফোলিও ও BrandEx-এর তৈরি কনটেন্টে আপনার ব্র্যান্ড যেভাবে দেখাবে।",
  "brand.preview": "আপনার পোর্টফোলিওর হেডারের প্রিভিউ",
  "brand.accentHint": "আপনার পাবলিক পোর্টফোলিওতে ব্যবহৃত হয়। BrandEx-নিরাপদ রঙ থেকে বেছে নিন।",
  "brand.images": "ছবি ও লোগো",
  "brand.imagesHint": "৫ MB পর্যন্ত PNG, JPEG বা WebP। আমরা আকার ঠিক করি এবং ফোনের ছবি থেকে লোকেশন তথ্য মুছে ফেলি।",
  "brand.slot.photo": "প্রোফাইল ছবি",
  "brand.slot.logo": "লোগো",
  "brand.slot.clinic_logo": "ক্লিনিকের লোগো (ঐচ্ছিক)",
  "brand.photoHint": "পরিষ্কার, সাম্প্রতিক ছবি; অন্তত ২০০ × ২০০ পিক্সেল।",
  "brand.logoHint": "স্বচ্ছ PNG সবচেয়ে ভালো দেখায়; অন্তত ৬৪ পিক্সেল।",
  "brand.upload": "আপলোড",
  "brand.replace": "বদলান",
  "brand.remove": "{slot} মুছুন",
  "brand.tooBig": "ফাইলটি ৫ MB-এর বেশি। ছোট ছবি বেছে নিন।",
  "brand.content": "কনটেন্টের পছন্দ",
  "brand.toneHint": "আপনার জন্য লেখা ক্যাপশন আপনার টোন মেনে চলে এবং সবসময় আপনার অনুমোদন লাগে।",
  "brand.tone": "ক্যাপশনের টোন",
  "brand.tone.warm_simple": "উষ্ণ ও সহজ",
  "brand.tone.professional_formal": "পেশাদার ও আনুষ্ঠানিক",
  "brand.tone.educational": "শিক্ষামূলক",
  "brand.save": "ব্র্যান্ড কিট সংরক্ষণ করুন",
  "brand.website": "ওয়েবসাইট",
  "brand.websiteHint": "আপনার ওয়েবসাইটের বিন্যাস বেছে নিন। প্রতিটি টেমপ্লেটে আপনার রং, ছবি ও একই যাচাই করা তথ্য থাকে।",
  "brand.template": "ওয়েবসাইট টেমপ্লেট",
  "brand.template.modern": "মডার্ন",
  "brand.template.modern.hint": "নামের পাশে বড় ছবি; বুকিং সামনে।",
  "brand.template.classic": "ক্লাসিক",
  "brand.template.classic.hint": "মাঝখানে সাজানো, রঙের ব্যান্ডসহ প্রচলিত চেম্বারের রূপ।",
  "brand.template.minimal": "মিনিমাল",
  "brand.template.minimal.hint": "পরিচ্ছন্ন ও লেখাভিত্তিক; রং শুধু দরকারি জায়গায়।",
  "brand.template.editorial": "এডিটোরিয়াল",
  "brand.template.editorial.hint": "স্বাস্থ্য ম্যাগাজিনের মতো, আপনার ভিডিও ও পোস্ট সামনে।",
  "brand.template.clinical": "ক্লিনিক্যাল",
  "brand.template.clinical.hint": "পরিষ্কার ও কাজের; হেডারেই চেম্বার ও সময়।",
  "brand.template.elegant": "এলিগ্যান্ট",
  "brand.template.elegant.hint": "গাঢ়, প্রিমিয়াম হেডার, সেরিফ শিরোনাম ও খিলান আকৃতির ছবি।",
  "brand.template.bold": "বোল্ড",
  "brand.template.bold.hint": "হেডার জুড়ে আপনার রং; বড় লেখা ও সংখ্যাযুক্ত অংশ।",
  "brand.template.warm": "ওয়ার্ম",
  "brand.template.warm.hint": "নরম, বন্ধুত্বপূর্ণ ও গোলাকার; ফ্যামিলি প্র্যাকটিসের জন্য আদর্শ।",
  "brand.template.spotlight": "স্পটলাইট",
  "brand.template.spotlight.hint": "পুরো প্রস্থের ব্যানারে আপনার ছবি, তার উপর আপনার নাম।",
  "brand.template.custom": "কাস্টম: {name}",
  "brand.template.custom.hint": "BrandEx-এর তৈরি, শুধু আপনার প্র্যাকটিসের জন্য ডিজাইন।",
  "brand.slot.favicon": "সাইট আইকন (ফেভিকন)",
  "brand.faviconHint": "কমপক্ষে ৪৮ × ৪৮ পিক্সেলের বর্গাকার ছবি, ব্রাউজারের ট্যাবে দেখা যাবে। না দিলে BrandEx-এর আইকন থাকবে।",
  "brand.custom.title": "কাস্টম টেমপ্লেট",
  "brand.custom.hint": "অন্যরকম কিছু চান? কী পছন্দ জানান, আমাদের ডিজাইন টিম আপনার প্র্যাকটিসের জন্য টেমপ্লেট বানাবে।",
  "brand.custom.brief": "আপনি কী চান?",
  "brand.custom.briefHint": "স্টাইল, রং, কেমন অনুভূতি চান, কী এড়াতে চান (কমপক্ষে ২০ অক্ষর)।",
  "brand.custom.references": "যে সাইটগুলো ভালো লাগে (ঐচ্ছিক)",
  "brand.custom.referencesHint": "সর্বোচ্চ ৫টি https:// লিংক, প্রতি লাইনে একটি।",
  "brand.custom.send": "অনুরোধ পাঠান",
  "brand.custom.sent": "অনুরোধ পাঠানো হয়েছে। আমাদের ডিজাইন টিম যোগাযোগ করবে।",
  "brand.custom.requests": "আপনার অনুরোধ",
  "brand.custom.status.open": "পাঠানো হয়েছে",
  "brand.custom.status.in_progress": "ডিজাইন চলছে",
  "brand.custom.status.delivered": "দেওয়া হয়েছে",
  "brand.custom.status.declined": "প্রত্যাখ্যাত",
  "brand.custom.status.cancelled": "প্রত্যাহার করা",
  "brand.custom.cancel": "প্রত্যাহার",
  "brand.custom.note": "BrandEx থেকে: {note}",
  "brand.custom.ready": "আপনার কাস্টম টেমপ্লেট “{name}” প্রস্তুত। ওয়েবসাইট টেমপ্লেট থেকে বেছে নিন।",
  "brand.custom.openRequest": "আপনার অনুরোধ আমাদের ডিজাইন টিমের কাছে আছে। শেষ হলে আরেকটি পাঠাতে পারবেন।",
  "brand.custom.badBrief": "আরেকটু বিস্তারিত লিখুন (কমপক্ষে ২০ অক্ষর)।",
  "brand.custom.badLinks": "সর্বোচ্চ ৫টি পূর্ণ https:// লিংক দিন।",
  "brand.showPosts": "আমার পোস্ট ওয়েবসাইটে দেখান",
  "brand.showPostsHint": "BrandEx আপনার জন্য যে কনটেন্ট প্রকাশ করেছে (ভিডিও, রিল, লেখা) তা কোথায় লাইভ সেই লিংকসহ সাইটে দেখা যাবে।",
  "brand.websiteDelay": "সংরক্ষিত পরিবর্তন সঙ্গে সঙ্গে আপনার ওয়েবসাইটে দেখা যাবে।",
  "nav.portfolio": "প্রোফাইল ও পোর্টফোলিও",
  "website.state.unpublished": "অপ্রকাশিত — শুধু আপনি দেখতে পাচ্ছেন",
  "profile.title": "প্রোফাইল ও পোর্টফোলিও",
  "profile.preview": "পোর্টফোলিও দেখুন",
  "profile.publish": "প্রকাশ করুন",
  "profile.unpublish": "প্রকাশ বন্ধ করুন",
  "profile.unpublishedHint": "আপনার পোর্টফোলিও রোগী ও সার্চ ইঞ্জিন থেকে লুকানো আছে। প্রস্তুত হলে আবার প্রকাশ করুন।",
  "profile.complete": "প্রোফাইল {percent}% সম্পূর্ণ",
  "profile.saved": "সংরক্ষিত হয়েছে। সঙ্গে সঙ্গে আপনার পোর্টফোলিওতে দেখা যাবে।",
  "profile.details": "আপনার তথ্য",
  "profile.detailsHint": "রোগীরা আপনার পোর্টফোলিওতে যা পড়েন। নাম, বিশেষত্ব ও ডিগ্রি আস্থা তৈরি করে; এগুলো সঠিক রাখুন।",
  "profile.saveDetails": "পরিবর্তন সংরক্ষণ করুন",
  "profile.chambers": "চেম্বার",
  "profile.chambersHint": "রোগীরা কোথায় ও কখন আপনাকে দেখাতে পারবেন। বুকিং এই সময় অনুযায়ী হয়।",
  "profile.saveChambers": "চেম্বার সংরক্ষণ করুন",
  "profile.faq": "পোর্টফোলিওর প্রশ্নোত্তর",
  "profile.faqHint": "উত্তর লিখুন বা খসড়া অনুমোদন করুন। শুধু অনুমোদিত উত্তর পাবলিক পেজে দেখা যায়।",
  "profile.faqSuggest": "সাধারণ প্রশ্ন যোগ করুন",
  "profile.faqEmpty": "এখনো কোনো প্রশ্ন নেই। আপনার বিশেষত্বের সাধারণ প্রশ্ন যোগ করুন বা নিজে লিখুন।",
  "profile.faqAnswer": "উত্তর",
  "profile.faqAnswerHint": "দুই-তিন বাক্যে সহজ, সাধারণ পরামর্শ। কখনো রোগনির্ণয় নয়।",
  "profile.faqApprove": "সংরক্ষণ ও উত্তর অনুমোদন করুন",
  "profile.faqSaveDraft": "খসড়া সংরক্ষণ করুন",
  "profile.faqRemove": "“{question}” মুছুন",
  "profile.faqNew": "নতুন প্রশ্ন",
  "profile.faqNewPlaceholder": "রোগীরা প্রায়ই যে প্রশ্ন করেন",
  "profile.faqAdd": "প্রশ্ন যোগ করুন",
  "profile.faqStatus.approved": "অনুমোদিত",
  "profile.faqStatus.draft": "খসড়া — পাবলিক নয়",
  "profile.faqStatus.needs_answer": "উত্তর দরকার",
  "profile.completeTitle": "প্রোফাইল সম্পূর্ণ করুন",
  "profile.completeHint": "আপনার প্রোফাইল থেকে BrandEx হিসাব করেছে।",
  "profile.step.bio": "১৫০ থেকে ৪০০ অক্ষরের পরিচিতি",
  "profile.step.degrees": "প্রতিষ্ঠানসহ ডিগ্রি",
  "profile.step.chambers": "অন্তত একটি চেম্বার",
  "profile.step.registration_no": "রেজিস্ট্রেশন নম্বর",
  "profile.step.profile_photo": "প্রোফাইল ছবি (ব্র্যান্ড কিট)",
  "profile.step.faq_answers": "অন্তত ৩টি অনুমোদিত প্রশ্নোত্তর",
  "profile.step.published": "পোর্টফোলিও প্রকাশিত",
  "profile.visibilityTitle": "সার্চ ও এআই দৃশ্যমানতা",
  "profile.visibilityHint": "BrandEx রক্ষণাবেক্ষণ করে। র‍্যাংকিংয়ের নিশ্চয়তা নেই; এটি পেজের কাজ।",
  "profile.check.title_and_description": "পেজের শিরোনাম ও বিবরণ",
  "profile.check.mobile_friendly": "মোবাইল-বান্ধব লেআউট",
  "profile.check.structured_data": "ডাক্তার ও প্রশ্নোত্তরের স্ট্রাকচার্ড ডেটা",
  "profile.check.faq_answers": "অন্তত ৩টি অনুমোদিত প্রশ্নোত্তর",
  "profile.check.profile_photo": "প্রোফাইল ছবি",
  "profile.check.sitemap": "সার্চ ইঞ্জিনের জন্য সাইটম্যাপ",
  "profile.step.services": "অন্তত ৩টি সেবা বা রোগের তালিকা",
  "profile.step.experience": "কর্মজীবনের অভিজ্ঞতা যোগ করা",
  "profile.check.social_profiles": "সোশ্যাল প্রোফাইল যুক্ত",
  "profile.check.services_listed": "সার্চের জন্য সেবার তালিকা",
  "website.address": "ওয়েবসাইটের ঠিকানা",
  "website.customDomain": "নিজস্ব ডোমেইন",
  "website.noDomain": "আপনার সাইট BrandEx ঠিকানা ব্যবহার করছে। নিজের ডোমেইন যুক্ত করতে টিমকে বলুন।",
  "website.domainConnected": "BrandEx যুক্ত করেছে। টিমের নির্দেশনা অনুযায়ী আপনার ডোমেইনের DNS BrandEx-এ দিন।",
  "website.upgrade": "ওয়েব পোর্টফোলিওসহ প্যাকেজে ডাক্তার ওয়েবসাইট থাকে। প্যাকেজ পাতায় পরিবর্তনের অনুরোধ করুন।",
  "website.offlineHint": "BrandEx আপনার সাইট সাময়িকভাবে বন্ধ রেখেছে। টিমের সাথে যোগাযোগ করুন।",
  "website.awaitingHint": "আমরা {url} সংরক্ষণ করেছি। BrandEx আপনার প্যাকেজ চালু করলেই এটি প্রকাশিত হবে।",
  "website.contents": "রোগীরা যা দেখবেন",
  "website.contentsHint": "আপনার সাইটে প্রোফাইল, ডিগ্রি, ভাষা এবং সাপ্তাহিক সময়সহ চেম্বার দেখানো হয়। প্রোফাইল থেকে এগুলো বদলাতে পারবেন।",
  "website.openPackage": "প্যাকেজ ও বিলিং খুলুন",
  "portfolio.language": "ভাষা",
  "portfolio.bookAppointment": "অ্যাপয়েন্টমেন্ট নিন",
  "portfolio.background": "পরিচিতি",
  "portfolio.specialisation": "বিশেষজ্ঞতা",
  "portfolio.degrees": "ডিগ্রি ও প্রশিক্ষণ",
  "portfolio.chambers": "চেম্বার ও সময়",
  "portfolio.languages": "ভাষা",
  "portfolio.registration": "রেজিস্ট্রেশন নং {value}",
  "portfolio.slot": "প্রতি রোগী {n} মিনিট",
  "portfolio.faq": "সাধারণ জিজ্ঞাসা",
  "portfolio.faqNote": "ডাক্তারের অনুমোদিত সাধারণ তথ্য। এটি রোগনির্ণয় নয়; নিজের স্বাস্থ্যের জন্য ডাক্তার দেখান।",
  "portfolio.logo": "লোগো",
  "portfolio.clinicLogo": "ক্লিনিকের লোগো",
  "portfolio.chamberHours": "চেম্বার ও সাপ্তাহিক সময়।",
  "portfolio.book.calendly": "ক্যালেন্ডলিতে বুক করুন",
  "portfolio.book.contactTitle": "বুক করতে ফোন বা হোয়াটসঅ্যাপ করুন",
  "portfolio.book.contactHint": "চেম্বার ফোনে আপনার অ্যাপয়েন্টমেন্ট ঠিক করে দেয়। কীভাবে যোগাযোগ করবেন বেছে নিন।",
  "portfolio.book.call": "ফোন করে বুক করুন",
  "portfolio.book.whatsapp": "হোয়াটসঅ্যাপে বুক করুন",
  "portfolio.book.whatsappText": "আসসালামু আলাইকুম, আপনার ওয়েবসাইট দেখে একটি অ্যাপয়েন্টমেন্ট নিতে চাই।",
  "portfolio.book.contactSay": "কোন চেম্বার ও কোন দিন সুবিধা এবং দেখানোর কারণ জানিয়ে দিন।",
  "portfolio.book.chamber": "চেম্বার",
  "portfolio.book.day": "দিন",
  "portfolio.book.time": "সময়",
  "portfolio.book.noSlots": "আগামী দুই সপ্তাহে খালি সময় নেই। চেম্বারে ফোন করুন।",
  "portfolio.book.name": "আপনার নাম",
  "portfolio.book.phone": "মোবাইল নম্বর",
  "portfolio.book.reason": "আসার কারণ (ঐচ্ছিক)",
  "portfolio.book.privacy": "আপনার নাম ও নম্বর শুধু ডাক্তারের চেম্বারে যায়, অ্যাপয়েন্টমেন্ট নিশ্চিত করতে।",
  "portfolio.book.submit": "অ্যাপয়েন্টমেন্ট চান",
  "portfolio.book.sending": "পাঠানো হচ্ছে…",
  "portfolio.book.requested": "অনুরোধ পাঠানো হয়েছে। চেম্বার আপনার অ্যাপয়েন্টমেন্ট নিশ্চিত করবে।",
  "portfolio.book.confirmed": "বুক হয়েছে। আপনার অ্যাপয়েন্টমেন্ট নিশ্চিত।",
  "portfolio.book.taken": "এইমাত্র কেউ ওই সময়টি নিয়েছেন। অন্য সময় বেছে নিন।",
  "portfolio.book.tooMany": "অনেক বেশি অনুরোধ। পরে চেষ্টা করুন বা চেম্বারে ফোন করুন।",
  "portfolio.book.badPhone": "01712-345678 এর মতো মোবাইল নম্বর দিন।",
  "portfolio.book.badName": "আপনার নাম লিখুন।",
  "portfolio.book.failed": "অনুরোধ পাঠানো যায়নি। আবার চেষ্টা করুন।",
  "portfolio.nav.label": "বিভাগ",
  "portfolio.nav.about": "পরিচিতি",
  "portfolio.nav.book": "বুক করুন",
  "portfolio.nav.chambers": "চেম্বার",
  "portfolio.nav.faq": "প্রশ্নোত্তর",
  "portfolio.credentials": "যোগ্যতা",
  "portfolio.findChamber": "চেম্বার খুঁজুন",
  "portfolio.consults": "রোগী দেখেন",
  "portfolio.chamberCount": "{n}টি চেম্বার",
  "portfolio.atAGlance": "এক নজরে",
  "portfolio.weeklyDays": "খোলা থাকার দিন",
  "portfolio.closed": "বন্ধ",
  "portfolio.directions": "পথনির্দেশ",
  "portfolio.hours.title": "কোথায় ও কখন",
  "portfolio.hours.openUntil": "এখন খোলা · {time} পর্যন্ত",
  "portfolio.hours.opensToday": "আজ {time}-এ খুলবে",
  "portfolio.hours.opensOn": "পরবর্তী: {day} {time}",
  "portfolio.hours.directionsTo": "{name}-এর পথনির্দেশ",
  "portfolio.hours.more": "সব চেম্বার দেখুন (+{n})",
  "portfolio.affiliations": "চিকিৎসা প্রতিষ্ঠান ও দায়িত্ব",
  "portfolio.care.eyebrow": "চিকিৎসার ক্ষেত্র",
  "portfolio.care.title": "আপনার যাত্রার প্রতিটি ধাপে",
  "portfolio.care.lead": "{name} যা দেখেন, সহজ ভাষায়।",
  "portfolio.care.book": "পরামর্শ বুক করুন",
  "portfolio.online.title": "ঘরে বসেই পরামর্শ",
  "portfolio.online.lead": "ভিডিও পরামর্শের ব্যবস্থা আছে।",
  "portfolio.online.book": "ভিডিও পরামর্শ বুক করুন",
  "portfolio.articles.title": "স্বাস্থ্য বিষয়ক লেখা",
  "portfolio.articles.lead": "সহজ ভাষায় পরামর্শ, ডাক্তারের লেখা ও অনুমোদিত।",
  "portfolio.articles.minutes": "{n} মিনিটে পড়ুন",
  "portfolio.social.title": "দেখুন ও ফলো করুন",
  "portfolio.social.lead": "{name}-এর চ্যানেলের ভিডিও ও পোস্ট।",
  "portfolio.social.tabs": "চ্যানেল",
  "portfolio.social.subscribers": "{n} সাবস্ক্রাইবার",
  "portfolio.social.followers": "{n} ফলোয়ার",
  "portfolio.social.follow": "{platform}-এ ফলো করুন",
  "portfolio.social.play": "“{title}” চালান",
  "portfolio.social.views": "{n} বার দেখা",
  "portfolio.social.open": "{platform}-এ খুলুন",
  "portfolio.social.reviews": "{n}টি Google রিভিউ",
  "portfolio.social.allReviews": "Google-এ সব রিভিউ দেখুন",
  "portfolio.social.fromGoogle": "Google থেকে নেওয়া রিভিউ, লেখকেরা যেভাবে লিখেছেন।",
  "portfolio.social.reply": "চেম্বারের উত্তর:",
  "portfolio.social.likes": "{n}টি লাইক",
  "portfolio.nav.care": "চিকিৎসা",
  "portfolio.cta.title": "অ্যাপয়েন্টমেন্ট নিতে চান?",
  "portfolio.cta.body": "আপনার সুবিধামতো চেম্বার ও সময় বেছে নিন। {name}-এর চেম্বার ফোনে নিশ্চিত করবে।",
  "portfolio.disclaimer": "এই ওয়েবসাইটের তথ্য সাধারণ, এটি চিকিৎসা পরামর্শ নয়। জরুরি প্রয়োজনে নিকটস্থ হাসপাতালে যান।",
  "portfolio.book.lead": "আপনার সুবিধামতো চেম্বার বেছে নিন। চেম্বার ফোনে আপনার অ্যাপয়েন্টমেন্ট নিশ্চিত করবে।",
  "portfolio.book.offline": "অনলাইন বুকিং এখনো চালু হয়নি। নিচের যেকোনো চেম্বারে যোগাযোগ করুন।",
  "portfolio.book.close": "বন্ধ করুন",
  "portfolio.book.ctaHint": "কীভাবে বুক করবেন দেখতে বোতামে চাপ দিন: ফোনে, হোয়াটসঅ্যাপে বা অনলাইনে।",
  "portfolio.book.calendlyHint": "এই ডাক্তারের অ্যাপয়েন্টমেন্ট ক্যালেন্ডলিতে নেওয়া হয়।",
  "portfolio.book.step.chamber": "চেম্বার বেছে নিন",
  "portfolio.book.step.time": "দিন ও সময় বেছে নিন",
  "portfolio.book.step.details": "আপনার তথ্য",
  "portfolio.book.morning": "সকাল",
  "portfolio.book.afternoon": "দুপুর",
  "portfolio.book.evening": "সন্ধ্যা",
  "portfolio.book.slotsFree": "{n}টি সময় খালি",
  "portfolio.book.pickTime": "অ্যাপয়েন্টমেন্টের সময় বেছে নিন।",
  "portfolio.book.requestedNext": "নিশ্চিত করতে আপনার মোবাইলে ফোন আসবে। ফোনটি কাছে রাখুন।",
  "portfolio.book.confirmedNext": "অনুগ্রহ করে ১০ মিনিট আগে আসুন এবং আগের রিপোর্ট সাথে আনুন।",
  "portfolio.book.another": "আরেকটি অ্যাপয়েন্টমেন্ট নিন",
  "portfolio.book.email": "ইমেইল (ঐচ্ছিক)",
  "portfolio.book.emailHint": "নিশ্চিতকরণ ও আগের দিনের রিমাইন্ডার ইমেইলে পাঠাব।",
  "portfolio.book.badEmail": "সঠিক ইমেইল দিন, অথবা খালি রাখুন।",
  "portfolio.book.fee": "কনসালটেশন ফি",
  "portfolio.book.feeOnline": "সময় ধরে রাখতে এখনই অনলাইনে পরিশোধ করুন।",
  "portfolio.book.feeAtChamber": "চেম্বারে পরিশোধ করবেন।",
  "portfolio.book.submitPay": "বুক করুন ও {fee} দিন",
  "portfolio.book.toPayment": "পেমেন্টে নিয়ে যাওয়া হচ্ছে…",
  "portfolio.book.reference": "আপনার রেফারেন্স: {ref}",
  "portfolio.book.manage": "বুকিং দেখুন, পরিবর্তন বা বাতিল করুন",
  "portfolio.book.manageHint": "লিংকটি রেখে দিন: অনলাইনে পরিবর্তন বা বাতিল করতে এটি লাগবে।",
  "appointment.title": "আপনার অ্যাপয়েন্টমেন্ট",
  "appointment.notFound": "এই বুকিং খুঁজে পাওয়া যায়নি। আপনাকে পাঠানো লিংকটি দেখুন।",
  "appointment.reference": "রেফারেন্স",
  "appointment.status.pending": "চেম্বারের নিশ্চিতকরণের অপেক্ষায়",
  "appointment.status.confirmed": "নিশ্চিত",
  "appointment.status.declined": "এই সময় পাওয়া যায়নি। অনুগ্রহ করে অন্য সময় বুক করুন।",
  "appointment.status.cancelled": "বাতিল",
  "appointment.cancelledBy.patient": "আপনি এই অ্যাপয়েন্টমেন্ট বাতিল করেছেন।",
  "appointment.cancelledBy.practice": "চেম্বার এই অ্যাপয়েন্টমেন্ট বাতিল করেছে।",
  "appointment.cancelledBy.unpaid": "পেমেন্ট সম্পন্ন হয়নি, তাই সময়টি ছেড়ে দেওয়া হয়েছে।",
  "appointment.when": "সময়",
  "appointment.where": "স্থান",
  "appointment.doctor": "ডাক্তার",
  "appointment.payment.pending": "পেমেন্ট বাকি। আপনার সময় {time} পর্যন্ত ধরে রাখা আছে।",
  "appointment.payment.paid": "পরিশোধিত {amount}",
  "appointment.payment.failed": "পেমেন্ট ব্যর্থ হয়েছে।",
  "appointment.payment.expired": "সময়মতো পেমেন্ট সম্পন্ন হয়নি।",
  "appointment.payment.refund_due": "{amount} পরিশোধিত। এটি ফেরত দেওয়া হবে।",
  "appointment.payNow": "এখন {amount} পরিশোধ করুন",
  "appointment.change": "সময় পরিবর্তন",
  "appointment.cancel": "অ্যাপয়েন্টমেন্ট বাতিল",
  "appointment.cancelConfirm": "এই অ্যাপয়েন্টমেন্ট বাতিল করবেন? সময়টি অন্য রোগীদের দেওয়া হবে।",
  "appointment.cancelYes": "হ্যাঁ, বাতিল করুন",
  "appointment.keep": "রেখে দিন",
  "appointment.pickNew": "নতুন সময় বেছে নিন",
  "appointment.movesLeft": "আপনি আরও {n} বার সময় পরিবর্তন করতে পারবেন।",
  "appointment.noMovesLeft": "আপনি ইতিমধ্যে দুবার সময় পরিবর্তন করেছেন। অনুগ্রহ করে চেম্বারে ফোন করুন।",
  "appointment.tooLate": "অ্যাপয়েন্টমেন্টের ২ ঘণ্টা আগে অনলাইন পরিবর্তন বন্ধ হয়। অনুগ্রহ করে চেম্বারে ফোন করুন।",
  "appointment.moved": "হয়ে গেছে। আপনার নতুন সময় {when}।",
  "appointment.cancelled": "আপনার অ্যাপয়েন্টমেন্ট বাতিল হয়েছে।",
  "appointment.taken": "এইমাত্র কেউ সময়টি নিয়েছেন। অনুগ্রহ করে অন্য সময় বেছে নিন।",
  "appointment.failed": "কিছু ভুল হয়েছে। আবার চেষ্টা করুন।",
  "appointment.bookAgain": "{doctor}-এর কাছে আবার বুক করুন",
  "appointment.save": "এই সময়ে সরান",
  "appointment.noSlots": "আগামী দুই সপ্তাহে অন্য কোনো খালি সময় নেই। অনুগ্রহ করে চেম্বারে ফোন করুন।",
  "pay.sandbox.title": "টেস্ট পেমেন্ট",
  "pay.sandbox.banner": "টেস্ট মোড: কোনো টাকা লেনদেন হয় না। এই পেজটি পেমেন্ট গেটওয়ের বদলে ব্যবহৃত।",
  "pay.sandbox.for": "{doctor}-এর সাথে কনসালটেশন",
  "pay.sandbox.amount": "পরিমাণ",
  "pay.sandbox.pay": "{amount} পরিশোধ (টেস্ট)",
  "pay.sandbox.fail": "পেমেন্ট ব্যর্থ করুন (টেস্ট)",
  "pay.sandbox.settled": "এই পেমেন্ট ইতিমধ্যে নিষ্পন্ন।",
  "pay.sandbox.notFound": "এই টেস্ট পেমেন্ট নেই, অথবা টেস্ট পেমেন্ট বন্ধ।",
  "pay.sandbox.back": "আপনার অ্যাপয়েন্টমেন্টে ফিরে যান",
  "portfolio.nav.posts": "ভিডিও ও পোস্ট",
  "portfolio.posts.title": "সাম্প্রতিক ভিডিও ও পোস্ট",
  "portfolio.posts.lead": "BrandEx-এর তৈরি এবং ডাক্তারের অনুমোদিত স্বাস্থ্যতথ্য।",
  "portfolio.posts.latest": "সর্বশেষ",
  "showcase.title": "পোর্টফোলিও হাইলাইটস",
  "showcase.hint": "অ্যাপয়েন্টমেন্টের আগে রোগীরা যা খোঁজেন: আপনি কী চিকিৎসা করেন, কোথায় কাজ করেছেন, আপনার স্বীকৃতি এবং আপনাকে কোথায় ফলো করা যায়।",
  "showcase.headline": "শিরোনাম",
  "showcase.headlineHint": "আপনার নামের নিচে এক লাইন। {count}/{max}",
  "showcase.headlinePlaceholder": "নিরাপদ মাতৃত্ব, যত্নশীল চিকিৎসা",
  "showcase.tagline": "ট্যাগলাইন (ঐচ্ছিক)",
  "showcase.taglineHint": "শিরোনামের ওপরে ছোট বড়-হাতের অক্ষরে কয়েকটি শব্দ। {count}/{max}",
  "showcase.taglinePlaceholder": "দক্ষতার সঙ্গে সহমর্মিতা",
  "showcase.emphasisPreview": "আপনার সাইটে:",
  "showcase.careAreas": "চিকিৎসার ক্ষেত্র",
  "showcase.careAreasHint": "হোম পেজে সর্বোচ্চ ৬টি নম্বর দেওয়া কার্ড: আপনি কী দেখেন, নিজের ভাষায়।",
  "showcase.addCareArea": "একটি ক্ষেত্র যোগ করুন",
  "showcase.removeCareArea": "ক্ষেত্র {n} সরান",
  "showcase.careTitle": "ক্ষেত্র {n}",
  "showcase.careTitlePlaceholder": "গর্ভাবস্থা ও প্রসব",
  "showcase.careDescription": "এখানে আপনি কী করেন (ঐচ্ছিক)",
  "showcase.careDescriptionHint": "সহজ ভাষায় এক-দুই বাক্য। {count}/{max}",
  "showcase.careDescriptionPlaceholder": "প্রসবপূর্ব চেকআপ, প্রসবের পরিকল্পনা এবং শিশুর জন্মের পরের যত্ন।",
  "showcase.online": "অনলাইন পরামর্শ",
  "showcase.onlineHint": "রোগীদের জানান যে আপনি ভিডিওতেও পরামর্শ দেন।",
  "showcase.onlineOffered": "আমি ভিডিও পরামর্শ দিই",
  "showcase.onlineNote": "নোট (ঐচ্ছিক)",
  "showcase.onlineNoteHint": "কখন বা কীসের জন্য, এক লাইনে।",
  "showcase.onlineNotePlaceholder": "ফলো-আপ ও দ্বিতীয় মতামত, শনিবার সন্ধ্যায়।",
  "showcase.onlineUrl": "বুকিং লিংক (ঐচ্ছিক)",
  "showcase.onlineUrlHint": "খালি রাখলে আপনার সাইটের বুকিং ব্যবহার হবে।",
  "showcase.since": "অভিজ্ঞতা: প্র্যাকটিস শুরুর বছর",
  "showcase.sinceHint": "যে বছর প্র্যাকটিস শুরু করেছেন। এ থেকে আপনার সাইটে অভিজ্ঞতার বছর দেখাবে, প্রতি বছর নিজে থেকেই হালনাগাদ হবে।",
  "showcase.sinceYears": "আপনার সাইটে দেখাবে {n}+ বছরের অভিজ্ঞতা।",
  "showcase.services": "সেবা ও যেসব রোগের চিকিৎসা করেন",
  "showcase.servicesHint": "রোগীরা যে শব্দে খোঁজেন। আপনার সাইটে ও সার্চ ইঞ্জিনে দেখানো হয়।",
  "showcase.addService": "সেবা বা রোগ যোগ করুন",
  "showcase.servicePlaceholder": "যেমন: ঝুঁকিপূর্ণ গর্ভাবস্থা",
  "showcase.serviceCount": "{max}টির মধ্যে {count}টি। যোগ করতে Enter চাপুন।",
  "showcase.removeService": "{name} সরান",
  "showcase.add": "যোগ করুন",
  "showcase.suggestions": "আপনার বিশেষজ্ঞতার জন্য পরামর্শ",
  "showcase.suggest.gynaecology_obstetrics": "গর্ভকালীন সেবা|ঝুঁকিপূর্ণ গর্ভাবস্থা|নরমাল ডেলিভারি|পিসিওএস|বন্ধ্যাত্ব|মাসিকের সমস্যা|মেনোপজ সেবা",
  "showcase.suggest.paediatrics": "নবজাতকের যত্ন|টিকা|শিশুর বৃদ্ধি ও পুষ্টি|জ্বর ও সংক্রমণ|শিশুদের হাঁপানি|বিকাশ পরীক্ষা",
  "showcase.suggest.medicine": "ডায়াবেটিস|উচ্চ রক্তচাপ|থাইরয়েডের সমস্যা|জ্বর ও সংক্রমণ|স্বাস্থ্য পরীক্ষা|গ্যাস্ট্রিকের সমস্যা",
  "showcase.suggest.cardiology": "বুকে ব্যথা|উচ্চ রক্তচাপ|হার্ট ফেইলিওর|ইসিজি ও ইকোকার্ডিওগ্রাফি|হার্ট অ্যাটাকের চিকিৎসা|কোলেস্টেরল নিয়ন্ত্রণ",
  "showcase.suggest.dermatology": "ব্রণ|একজিমা|সোরিয়াসিস|চুল পড়া|ত্বকের অ্যালার্জি|ছত্রাক সংক্রমণ",
  "showcase.suggest.orthopaedics": "কোমর ব্যথা|হাঁটু ব্যথা|হাড় ভাঙা|আর্থ্রাইটিস|খেলাধুলার আঘাত|জয়েন্ট প্রতিস্থাপন",
  "showcase.suggest.other": "পরামর্শ|স্বাস্থ্য পরীক্ষা|ফলো-আপ সেবা",
  "showcase.experience": "অভিজ্ঞতা",
  "showcase.experienceHint": "যেসব পদে কাজ করেছেন, সর্বশেষটি আগে।",
  "showcase.role": "পদ",
  "showcase.rolePlaceholder": "সহযোগী অধ্যাপক",
  "showcase.organization": "হাসপাতাল বা প্রতিষ্ঠান",
  "showcase.from": "শুরু",
  "showcase.to": "শেষ",
  "showcase.present": "বর্তমান",
  "showcase.current": "এখন এখানে কর্মরত",
  "showcase.addExperience": "পদ যোগ করুন",
  "showcase.removeExperience": "{n} নম্বর পদ সরান",
  "showcase.awards": "পুরস্কার ও স্বীকৃতি",
  "showcase.awardsHint": "পুরস্কার, ফেলোশিপ ও সম্মাননা।",
  "showcase.awardTitle": "পুরস্কার",
  "showcase.awardIssuer": "প্রদানকারী",
  "showcase.addAward": "পুরস্কার যোগ করুন",
  "showcase.removeAward": "{n} নম্বর পুরস্কার সরান",
  "showcase.year": "বছর",
  "showcase.memberships": "পেশাগত সদস্যপদ",
  "showcase.membershipsHint": "মেডিকেল সোসাইটি ও অ্যাসোসিয়েশন।",
  "showcase.membershipOrg": "সোসাইটি বা অ্যাসোসিয়েশন",
  "showcase.membershipPlaceholder": "বাংলাদেশ মেডিকেল অ্যাসোসিয়েশন",
  "showcase.membershipRole": "ভূমিকা (ঐচ্ছিক)",
  "showcase.membershipRolePlaceholder": "আজীবন সদস্য",
  "showcase.addMembership": "সদস্যপদ যোগ করুন",
  "showcase.removeMembership": "{n} নম্বর সদস্যপদ সরান",
  "showcase.publications": "প্রকাশনা ও গণমাধ্যম",
  "showcase.publicationsHint": "গবেষণাপত্র, বই, টিভি ও পত্রিকার ফিচার, বক্তৃতা।",
  "showcase.publicationKind": "ধরন",
  "showcase.kind.journal": "জার্নালে গবেষণাপত্র",
  "showcase.kind.book": "বই বা অধ্যায়",
  "showcase.kind.media": "গণমাধ্যমে উপস্থিতি",
  "showcase.kind.talk": "বক্তৃতা বা সেমিনার",
  "showcase.venue.journal": "জার্নাল",
  "showcase.venue.book": "প্রকাশক",
  "showcase.venue.media": "পত্রিকা, চ্যানেল বা অনুষ্ঠান",
  "showcase.venue.talk": "অনুষ্ঠান",
  "showcase.publicationTitle": "শিরোনাম",
  "showcase.publicationUrl": "লিংক (ঐচ্ছিক)",
  "showcase.addPublication": "যোগ করুন",
  "showcase.removePublication": "{n} নম্বর আইটেম সরান",
  "showcase.links": "সোশ্যাল প্রোফাইল",
  "showcase.linksHint": "লিংকগুলো সার্চ ইঞ্জিন ও এআই সহকারীকে আপনাকে চিনতে সাহায্য করে।",
  "showcase.network.facebook": "ফেসবুক",
  "showcase.network.youtube": "ইউটিউব",
  "showcase.network.instagram": "ইনস্টাগ্রাম",
  "showcase.network.linkedin": "লিংকডইন",
  "showcase.network.x": "এক্স (টুইটার)",
  "showcase.network.tiktok": "টিকটক",
  "showcase.network.website": "অন্য ওয়েবসাইট",
  "showcase.save": "হাইলাইটস সংরক্ষণ করুন",
  "showcase.fixErrors": "চিহ্নিত ঘরগুলো দেখে নিন।",
  "showcase.error.headline": "সর্বোচ্চ ১২০ অক্ষর ব্যবহার করুন।",
  "showcase.error.tagline": "সর্বোচ্চ ৬০ অক্ষর ব্যবহার করুন।",
  "showcase.error.emphasis": "যে শব্দে জোর দিতে চান তা দুটি * এর মাঝে রাখুন, যেমন *যত্নশীল চিকিৎসা*।",
  "showcase.error.tooLong": "এটি অনেক বড়।",
  "showcase.error.year": "১৯৫০ থেকে চলতি বছরের মধ্যে একটি সাল লিখুন।",
  "showcase.error.order": "শুরুর বছরের আগে হতে পারবে না।",
  "showcase.error.required": "এটি পূরণ করুন, অথবা সারিটি সরান।",
  "showcase.error.service": "২ থেকে ৮০ অক্ষর ব্যবহার করুন।",
  "showcase.error.duplicate": "এটি তালিকায় আগেই আছে।",
  "showcase.error.link": "পূর্ণ https:// লিংক দিন।",
  "showcase.error.network": "এই নেটওয়ার্কে আপনার প্রোফাইলের https:// লিংক দিন।",
  "portfolio.nav.services": "সেবা",
  "portfolio.nav.experience": "অভিজ্ঞতা",
  "portfolio.services.title": "সেবা ও যেসব রোগের চিকিৎসা করেন",
  "portfolio.services.lead": "রোগীরা যে কারণে {name}-এর কাছে আসেন।",
  "portfolio.experience": "অভিজ্ঞতা",
  "portfolio.present": "বর্তমান",
  "portfolio.years": "{n}+ বছর",
  "portfolio.yearsLabel": "প্র্যাকটিসে",
  "portfolio.experience.years": "{n}+",
  "portfolio.experience.label": "বছরের অভিজ্ঞতা",
  "portfolio.experience.since": "{year} সাল থেকে",
  "portfolio.recognition": "পুরস্কার ও স্বীকৃতি",
  "portfolio.memberships": "পেশাগত সদস্যপদ",
  "portfolio.publications": "প্রকাশনা ও গণমাধ্যম",
  "portfolio.kind.journal": "গবেষণাপত্র",
  "portfolio.kind.book": "বই",
  "portfolio.kind.media": "গণমাধ্যম",
  "portfolio.kind.talk": "বক্তৃতা",
  "portfolio.open": "দেখুন",
  "portfolio.follow": "{name}-কে ফলো করুন",
  "portfolio.posts.on.website": "পড়ুন",
  "portfolio.posts.on.youtube": "ইউটিউবে দেখুন",
  "portfolio.posts.on.facebook": "ফেসবুকে দেখুন",
  "portfolio.posts.on.instagram": "ইনস্টাগ্রামে দেখুন",
  "portfolio.posts.on.tiktok": "টিকটকে দেখুন",
  "portfolio.posts.on.linkedin": "লিংকডইনে পড়ুন",
  "portfolio.nav.articles": "প্রবন্ধ",
  "portfolio.nav.social": "সোশ্যাল",
  "portfolio.blog.title": "স্বাস্থ্যবিষয়ক প্রবন্ধ",
  "portfolio.blog.lead": "BrandEx-এর সঙ্গে লেখা এবং ডাক্তারের অনুমোদিত স্বাস্থ্যতথ্য।",
  "portfolio.blog.empty": "এখনও কোনো প্রবন্ধ নেই। শিগগিরই আবার দেখুন।",
  "portfolio.blog.read": "প্রবন্ধটি পড়ুন",
  "portfolio.blog.back": "সব প্রবন্ধ",
  "portfolio.blog.older": "পুরোনো প্রবন্ধ",
  "portfolio.blog.newer": "নতুন প্রবন্ধ",
  "portfolio.blog.by": "লেখক: {name}",
  "portfolio.blog.home": "{name}-এর সাইটে ফিরে যান",
  "portfolio.blog.featured": "সর্বশেষ লেখা",
  "portfolio.blog.contents": "এই পাতায়",
  "portfolio.blog.share": "শেয়ার করুন",
  "portfolio.blog.shareOn": "{network}-এ শেয়ার করুন",
  "portfolio.blog.more": "{name}-এর আরও লেখা",
  "portfolio.blog.ctaTitle": "নিজের স্বাস্থ্য নিয়ে প্রশ্ন আছে?",
  "portfolio.blog.ctaBody": "লেখাগুলো সাধারণ তথ্য। আপনার জন্য পরামর্শ পেতে {name}-এর সাথে অ্যাপয়েন্টমেন্ট নিন।",
  "portfolio.blog.medicalNote": "এই লেখাটি সাধারণ স্বাস্থ্য তথ্য, রোগনির্ণয় নয়। নিজের উপসর্গের জন্য ডাক্তার দেখান। জরুরি অবস্থায় নিকটস্থ হাসপাতালে যান।",
  "portfolio.by": "পোর্টফোলিও: BrandEx",
  "portfolio.notFound": "এই ডাক্তারের পাতা এখন পাওয়া যাচ্ছে না।",
  "auth.choosePassword": "আপনার পাসওয়ার্ড বেছে নিন",
  "auth.setupIntro": "BrandEx টিম আপনার অ্যাকাউন্ট ও প্রোফাইল তৈরি করেছে। লগইন করতে একটি পাসওয়ার্ড বেছে নিন।",
  "auth.savePassword": "পাসওয়ার্ড সংরক্ষণ করুন",
  "auth.passwordSaved": "পাসওয়ার্ড সংরক্ষিত হয়েছে। অনুগ্রহ করে লগইন করুন।",
  "clientOnboarding.title": "ক্লায়েন্ট অনবোর্ড করুন",
  "clientOnboarding.account": "ডাক্তারের অ্যাকাউন্ট",
  "clientOnboarding.inviteLanguage": "আমন্ত্রণ ইমেইল ও পোর্টালের ভাষা",
  "clientOnboarding.submit": "ক্লায়েন্ট তৈরি করে আমন্ত্রণ পাঠান",
  "nav.articles": "প্রবন্ধ",
  "nav.social": "সোশ্যাল মিডিয়া",
  "social.title": "সোশ্যাল মিডিয়া",
  "social.subtitle": "আপনার চ্যানেল যুক্ত করুন, প্রতিটি পোস্ট ও তার সংখ্যা দেখুন, আর সেরাগুলো ওয়েবসাইটে পিন করুন।",
  "social.subtitle.staff": "এই ক্লায়েন্টের চ্যানেল: যুক্ত করুন, সংখ্যা দেখুন, আর ওয়েবসাইটে কী দেখাবে ঠিক করুন। প্রতিটি পরিবর্তন রেকর্ড থাকে।",
  "social.tabs": "প্ল্যাটফর্ম",
  "social.overview": "সারসংক্ষেপ",
  "social.platform.youtube": "YouTube",
  "social.platform.facebook": "Facebook",
  "social.platform.instagram": "Instagram",
  "social.platform.tiktok": "TikTok",
  "social.platform.linkedin": "LinkedIn",
  "social.platform.google": "Google রিভিউ",
  "social.connect.signIn": "{platform} দিয়ে চালিয়ে যান",
  "social.connect.reconnect": "আবার যুক্ত করুন",
  "social.connect.staffSignIn": "ক্লায়েন্টের {platform} পরিচালনা করে এমন অ্যাকাউন্ট দিয়ে সাইন ইন করুন, অথবা ডাক্তারকে তাঁর পোর্টাল থেকে যুক্ত করতে বলুন।",
  "social.connect.inBrowser": "ব্রাউজারে {platform}-এ সাইন ইন শেষ করুন। অ্যাকাউন্ট সেখানে, ওয়েব পোর্টালে বেছে নেবেন।",
  "social.callbackMissing.staff": "BrandEx-এর পাবলিক API ঠিকানা এখনও সেট করা হয়নি: সুপার অ্যাডমিন Social health → Integrations-এ সেট করবেন।",
  "social.connect.facebook.lead": "Facebook দিয়ে সাইন ইন করে চেম্বারের পেজ বেছে নিন। পোস্ট, রিঅ্যাকশন, মন্তব্য ও শেয়ার পড়া হয়; কখনো কিছু পোস্ট করা হয় না।",
  "social.connect.instagram.lead": "Facebook দিয়ে সাইন ইন করুন (Instagram প্রফেশনাল অ্যাকাউন্ট একটি পেজের সঙ্গে যুক্ত থাকে) এবং অ্যাকাউন্টটি বেছে নিন। পোস্ট ও রিল লাইক ও মন্তব্যসহ পড়া হয়।",
  "social.connect.tiktok.lead": "চেম্বারের TikTok অ্যাকাউন্ট দিয়ে সাইন ইন করুন। পাবলিক ভিডিও ভিউ, লাইক, মন্তব্য ও শেয়ারসহ পড়া হয়।",
  "social.connect.linkedin.lead": "LinkedIn দিয়ে সাইন ইন করে প্রতিষ্ঠানের Company Page বেছে নিন। পোস্ট লাইক ও মন্তব্যসহ পড়া হয়।",
  "social.connect.google.lead": "চেম্বারের Business Profile পরিচালনা করে এমন Google অ্যাকাউন্ট দিয়ে সাইন ইন করে লোকেশন বেছে নিন। প্রতিটি রিভিউ তারা ও উত্তরসহ পড়া হয়।",
  "social.stats.rating": "গড় রেটিং",
  "social.stats.reviews": "রিভিউ",
  "social.stats.synced": "সিঙ্ক হয়েছে",
  "social.site.rating": "গড় রেটিং ও রিভিউর সংখ্যা দেখান",
  "social.fill.highest_rated": "সবচেয়ে ভালো রেটিং",
  "social.sort.highest_rated": "সেরা রেটিং",
  "social.kind.review": "রিভিউ",
  "social.review.stars": "৫-এর মধ্যে {n} তারা",
  "social.review.by": "{name}-এর রিভিউ",
  "social.review.noText": "শুধু তারা, কোনো লেখা নেই।",
  "social.review.reply": "আপনার উত্তর:",
  "social.choose.title": "যুক্ত করার জন্য {platform} অ্যাকাউন্ট বেছে নিন",
  "social.choose.lead": "এগুলো আপনি পরিচালনা করেন। চেম্বারেরটি বেছে নিন।",
  "social.choose.expired": "এই সাইন-ইনের মেয়াদ শেষ। যুক্ত করুন বোতাম দিয়ে আবার শুরু করুন।",
  "social.choose.connect": "এই অ্যাকাউন্ট যুক্ত করুন",
  "social.signIn.expired": "সাইন-ইনে অনেক দেরি হয়েছে বা এটি আগেই ব্যবহার হয়েছে। আবার চেষ্টা করুন।",
  "social.signIn.denied": "সাইন-ইন বাতিল হয়েছে, তাই কিছু যুক্ত হয়নি।",
  "social.signIn.failed": "প্ল্যাটফর্ম সাইন-ইন গ্রহণ করেনি। আবার চেষ্টা করুন; বারবার ব্যর্থ হলে নিচের গাইড দেখুন।",
  "social.signIn.no_accounts": "এই অ্যাকাউন্ট আমাদের যুক্ত করার মতো কোনো পেজ বা প্রোফাইল পরিচালনা করে না। নিচের গাইড দেখুন।",
  "social.signIn.dismiss": "বন্ধ করুন",
  "social.guide.facebook.sync.title": "প্রথম সিঙ্কের অপেক্ষা করুন",
  "social.guide.facebook.sync.body": "পেজের পোস্ট রিঅ্যাকশন, মন্তব্য ও শেয়ারসহ কয়েক মিনিটে লোড হয়; নতুন পোস্ট নিজে থেকেই আসে।",
  "social.guide.instagram.sync.title": "প্রথম সিঙ্কের অপেক্ষা করুন",
  "social.guide.instagram.sync.body": "পোস্ট ও রিল লাইক ও মন্তব্যসহ কয়েক মিনিটে লোড হয়।",
  "social.guide.tiktok.renew.title": "বছরে একবার আবার যুক্ত করুন",
  "social.guide.tiktok.renew.body": "TikTok-এর অনুমতি এক বছর থাকে। ততদিন আমরা প্রতিদিন নবায়ন করি, আর TikTok চাইলে আবার যুক্ত করতে বলি।",
  "social.guide.linkedin.page.title": "একটি LinkedIn Company Page রাখুন",
  "social.guide.linkedin.page.body": "LinkedIn অ্যাপকে শুধু Company Page-এর পোস্ট দেয়, ব্যক্তিগত প্রোফাইলের নয়। না থাকলে প্রতিষ্ঠানের জন্য একটি পেজ তৈরি করুন।",
  "social.guide.linkedin.admin.title": "পেজের সুপার অ্যাডমিন হোন",
  "social.guide.linkedin.admin.body": "যিনি যুক্ত করবেন তাঁকে পেজের অ্যাডমিন হতে হবে (Page → Settings → Manage admins)।",
  "social.guide.linkedin.connect.title": "LinkedIn দিয়ে চালিয়ে যান",
  "social.guide.linkedin.connect.body": "সাইন ইন করে অনুমতি দিন এবং পেজটি বেছে নিন। অনুমতি ৬০ দিন থাকে এবং নিজে থেকেই নবায়ন হয়।",
  "social.guide.google.profile.title": "একটি যাচাই করা Business Profile রাখুন",
  "social.guide.google.profile.body": "রিভিউ আসে চেম্বারের Google Business Profile (Google Maps-এর তালিকা) থেকে। এটি যাচাই করা থাকতে হবে।",
  "social.guide.google.manager.title": "মালিক বা ম্যানেজার হিসেবে সাইন ইন করুন",
  "social.guide.google.manager.body": "প্রোফাইলের মালিক বা ম্যানেজার Google অ্যাকাউন্ট ব্যবহার করুন (Business Profile → ⋮ → Business Profile settings → People and access)।",
  "social.guide.google.connect.title": "Google দিয়ে চালিয়ে যান এবং লোকেশন বেছে নিন",
  "social.guide.google.connect.body": "BrandEx-কে প্রোফাইল দেখার অনুমতি দিন, তারপর চেম্বারটি বেছে নিন।",
  "social.guide.google.sync.title": "প্রথম সিঙ্কের অপেক্ষা করুন",
  "social.guide.google.sync.body": "প্রতিটি রিভিউ তারা, লেখা ও আপনার উত্তরসহ লোড হয়। গড় ও মোট সংখ্যা সরাসরি Google থেকে আসে।",
  "social.status.ok": "যুক্ত",
  "social.status.pending": "পোস্ট লোড হচ্ছে",
  "social.status.needs_reconnect": "আবার যুক্ত করতে হবে",
  "social.status.failing": "সিঙ্কে সমস্যা",
  "social.status.not_connected": "যুক্ত নয়",
  "social.status.soon": "শিগগিরই আসছে",
  "social.overview.posts": "{posts}টি পোস্ট · {max}টির মধ্যে {pinned}টি পিন করা",
  "social.overview.synced": "সিঙ্ক {when}",
  "social.overview.connect": "ওয়েবসাইটে পোস্ট দেখাতে {platform} যুক্ত করুন।",
  "social.overview.soon": "{platform} যুক্ত করার ব্যবস্থা চলছে। প্রস্তুত থাকতে গাইড দেখুন।",
  "social.stats.subscribers": "সাবস্ক্রাইবার",
  "social.stats.followers": "ফলোয়ার",
  "social.stats.views": "মোট ভিউ",
  "social.stats.posts": "পোস্ট",
  "social.connect.title": "{platform} যুক্ত করুন",
  "social.connect.prepare": "গাইডের ধাপগুলো দিয়ে অ্যাকাউন্ট এখনই প্রস্তুত রাখুন, তাহলে চালু হলে যুক্ত করতে এক মিনিট লাগবে।",
  "social.connect.button": "{platform} যুক্ত করুন",
  "social.connect.youtube.lead": "চ্যানেলের লিংক পেস্ট করুন। শুধু পাবলিক ভিডিও ও সংখ্যা পড়া হয়; কাউকে সাইন ইন করতে হয় না।",
  "social.connect.youtube.label": "YouTube চ্যানেলের লিংক",
  "social.connect.youtube.hint": "যেমন youtube.com/@yourchannel, অথবা UC দিয়ে শুরু হওয়া চ্যানেল আইডি।",
  "social.connect.youtube.placeholder": "https://www.youtube.com/@yourchannel",
  "social.connect.youtube.notFound": "YouTube এই চ্যানেলটি চেনে না। চ্যানেলের পেজ থেকে লিংকটি (যাতে @ আছে) কপি করে আবার চেষ্টা করুন।",
  "social.notConfigured.doctor": "BrandEx এখনও {platform} যুক্ত করার ব্যবস্থা করছে। যুক্ত করা গেলে আমরা জানাব।",
  "social.notConfigured.staff": "এই সার্ভারে {platform} এখনও কনফিগার করা হয়নি: ক্লায়েন্টরা যুক্ত করার আগে এর অ্যাপ কী সেট করতে হবে।",
  "social.account.title": "যুক্ত অ্যাকাউন্ট",
  "social.account.syncNow": "এখনই সিঙ্ক করুন",
  "social.account.disconnect": "বিচ্ছিন্ন করুন",
  "social.account.disconnectConfirm": "অ্যাকাউন্ট ও তার পোস্ট সরাবেন?",
  "social.account.disconnectYes": "বিচ্ছিন্ন করুন",
  "social.account.loading": "প্রথমবার পোস্ট লোড হচ্ছে। কয়েক মিনিট লাগে; পেজটি নিজে থেকেই হালনাগাদ হবে।",
  "social.account.synced": "{when} {source} থেকে সিঙ্ক হয়েছে।",
  "social.site.title": "আপনার ওয়েবসাইটে",
  "social.site.on": "ওয়েবসাইটে আছে",
  "social.site.off": "ওয়েবসাইটে নেই",
  "social.site.show": "ওয়েবসাইটে এই প্ল্যাটফর্ম দেখান",
  "social.site.showHint": "পিন করা পোস্ট আগে আসে; লুকানো পোস্ট কখনো দেখায় না।",
  "social.site.count": "কয়টি পোস্ট দেখাবে",
  "social.site.countN": "{n}টি পোস্ট",
  "social.site.fill": "পিন করা পোস্টের পরে দেখান",
  "social.site.fillHint": "বাকি জায়গাগুলো নিজে থেকেই পূরণ হয়।",
  "social.site.subscribers": "সাবস্ক্রাইবারের সংখ্যা দেখান",
  "social.site.followers": "ফলোয়ারের সংখ্যা দেখান",
  "social.site.followersHint": "প্ল্যাটফর্ম থেকে পড়া হয়; সংখ্যা কম থাকলে বন্ধ রাখুন।",
  "social.fill.latest": "সাম্প্রতিক পোস্ট",
  "social.fill.most_viewed": "সবচেয়ে বেশি দেখা",
  "social.fill.most_reactions": "সবচেয়ে বেশি পছন্দ করা",
  "social.pinned.title": "পিন করা ({max}টির মধ্যে {pinned}টি)",
  "social.pinned.hint": "ওয়েবসাইটে এই ক্রমে সবার আগে দেখায়।",
  "social.pinned.empty": "এখনও কিছু পিন করা হয়নি। নিচের তালিকা থেকে সর্বোচ্চ তিনটি পোস্ট পিন করুন।",
  "social.pinned.earlier": "“{title}” আগে আনুন",
  "social.pinned.later": "“{title}” পরে নিন",
  "social.posts.title": "{platform}-এর সব পোস্ট",
  "social.posts.show": "দেখান",
  "social.posts.sort": "সাজান",
  "social.posts.search": "ক্যাপশনে খুঁজুন",
  "social.posts.loadingTitle": "পোস্ট লোড হচ্ছে",
  "social.posts.emptyTitle": "কোনো পোস্ট নেই",
  "social.posts.empty": "এই {platform} অ্যাকাউন্টে এখনও কোনো পাবলিক পোস্ট নেই।",
  "social.posts.noMatch": "কোনো পোস্ট মেলেনি।",
  "social.posts.more": "আরও দেখান",
  "social.show.all": "সব",
  "social.show.pinned": "পিন করা",
  "social.show.hidden": "লুকানো",
  "social.sort.newest": "সর্বশেষ",
  "social.sort.most_viewed": "সবচেয়ে বেশি দেখা",
  "social.sort.most_reactions": "সবচেয়ে বেশি পছন্দ",
  "social.sort.most_reach": "সবচেয়ে বেশি রিচ",
  "social.kind.video": "ভিডিও",
  "social.kind.post": "পোস্ট",
  "social.kind.photo": "ছবি",
  "social.kind.carousel": "ক্যারোসেল",
  "social.kind.reel": "রিল",
  "social.metric.label": "সংখ্যা",
  "social.metric.views": "ভিউ",
  "social.metric.reach": "রিচ",
  "social.metric.reactions": "লাইক",
  "social.metric.comments": "মন্তব্য",
  "social.metric.shares": "শেয়ার",
  "social.post.untitled": "শিরোনামহীন পোস্ট",
  "social.post.open": "“{title}” প্ল্যাটফর্মে খুলুন",
  "social.post.pin": "পিন",
  "social.post.unpin": "পিন সরান",
  "social.post.pinLabel": "“{title}” ওয়েবসাইটে পিন করুন",
  "social.post.unpinLabel": "“{title}”-এর পিন সরান",
  "social.post.pinnedN": "পিন {n}",
  "social.post.pinsFull": "তিনটি পোস্ট পিন করা আছে। আগে একটির পিন সরান।",
  "social.post.cantPin": "লুকানো বা সরানো পোস্ট পিন করা যায় না।",
  "social.post.hide": "লুকান",
  "social.post.show": "দেখান",
  "social.post.hideLabel": "“{title}” ওয়েবসাইট থেকে লুকান",
  "social.post.showLabel": "“{title}” আবার ওয়েবসাইটে দেখান",
  "social.post.hidden": "লুকানো",
  "social.post.removed": "প্ল্যাটফর্ম থেকে সরানো হয়েছে",
  "social.guide.title": "{platform} কীভাবে যুক্ত করবেন",
  "social.guide.howItWorks": "{platform} সংযোগ কীভাবে কাজ করে",
  "social.guide.help": "{platform} সাহায্য",
  "social.guide.staffNote": "“ডাক্তার” চিহ্নিত ধাপগুলোর জন্য ডাক্তারের নিজের অ্যাকাউন্ট লাগে। তাঁকে এই গাইড পাঠান; বাকিটা আপনি করতে পারবেন।",
  "social.guide.doctorStep": "ডাক্তার",
  "social.guide.state.done": "সম্পন্ন",
  "social.guide.state.todo": "বাকি",
  "social.guide.state.unknown": "এখনও যাচাই হয়নি",
  "social.guide.youtube.find.title": "চ্যানেলের লিংক কপি করুন",
  "social.guide.youtube.find.body": "কম্পিউটারে চ্যানেলটি খুলে ঠিকানা (youtube.com/@…) কপি করুন। অ্যাপে চ্যানেলটি খুলে ⋮ বা শেয়ার চাপুন, তারপর লিংক কপি করুন।",
  "social.guide.youtube.paste.title": "পেস্ট করে যুক্ত করুন",
  "social.guide.youtube.paste.body": "সেভ করার আগে আমরা YouTube-এর সঙ্গে চ্যানেলটি যাচাই করি। শুধু পাবলিক ভিডিও ও সংখ্যা পড়া হয়।",
  "social.guide.youtube.sync.title": "প্রথম সিঙ্কের অপেক্ষা করুন",
  "social.guide.youtube.sync.body": "প্রতিটি পাবলিক ভিডিও তার ভিউ, লাইক ও মন্তব্যসহ সাধারণত কয়েক মিনিটে লোড হয়। এরপর নতুন ভিডিও নিজে থেকেই আসে।",
  "social.guide.youtube.choose.title": "সেরা ভিডিওগুলো পিন করুন",
  "social.guide.youtube.choose.body": "সর্বোচ্চ তিনটি পিন করুন, ওয়েবসাইটে না চাইলে লুকান, আর কয়টি দেখাবে ঠিক করুন।",
  "social.guide.facebook.page.title": "একটি Facebook পেজ রাখুন",
  "social.guide.facebook.page.body": "পোস্ট আসে Facebook পেজ থেকে, ব্যক্তিগত প্রোফাইল থেকে নয়। চেম্বারের জন্য পেজ না থাকলে একটি তৈরি করুন।",
  "social.guide.facebook.control.title": "পেজের পূর্ণ নিয়ন্ত্রণ রাখুন",
  "social.guide.facebook.control.body": "যিনি যুক্ত করবেন তাঁর পেজে পূর্ণ নিয়ন্ত্রণ থাকতে হবে (পেজ সেটিংস → পেজ অ্যাক্সেস)।",
  "social.guide.facebook.connect.title": "Facebook দিয়ে চালিয়ে যান",
  "social.guide.facebook.connect.body": "সাইন ইন করে পেজের অনুমতি দিন এবং পেজটি বেছে নিন। কেউ কখনো পাসওয়ার্ড চাইবে না; Facebook-এর সেটিংস থেকে যেকোনো সময় BrandEx সরাতে পারবেন।",
  "social.guide.instagram.professional.title": "প্রফেশনাল অ্যাকাউন্ট ব্যবহার করুন",
  "social.guide.instagram.professional.body": "Instagram শুধু প্রফেশনাল (Creator বা Business) অ্যাকাউন্টের পোস্ট ও সংখ্যা দেয়। বদলানো বিনামূল্যে: সেটিংস → অ্যাকাউন্টের ধরন ও টুল।",
  "social.guide.instagram.link.title": "Facebook পেজের সঙ্গে লিংক করুন",
  "social.guide.instagram.link.body": "Accounts Center-এ Instagram অ্যাকাউন্টটি চেম্বারের Facebook পেজের সঙ্গে যুক্ত করুন, যাতে এক সংযোগেই দুটো চলে।",
  "social.guide.instagram.connect.title": "Facebook দিয়ে চালিয়ে যান এবং Instagram অ্যাকাউন্ট বেছে নিন",
  "social.guide.instagram.connect.body": "Instagram প্রফেশনাল অ্যাকাউন্ট যে Facebook পেজের সঙ্গে যুক্ত, তার মাধ্যমে সাইন ইন হয়।",
  "social.guide.tiktok.login.title": "TikTok অ্যাকাউন্টে সাইন ইন করতে পারা",
  "social.guide.tiktok.login.body": "TikTok যুক্ত হয় অ্যাকাউন্টে সাইন ইন করে, বছরে একবার। নিশ্চিত করুন ডাক্তার (বা যিনি চালান) সাইন ইন করতে পারেন।",
  "social.guide.tiktok.connect.title": "TikTok দিয়ে চালিয়ে যান",
  "social.guide.tiktok.connect.body": "চেম্বারের TikTok-এ সাইন ইন করে প্রোফাইল, সংখ্যা ও ভিডিওর অনুমতি দিন।",
  "social.problem.title": "সাধারণ সমস্যা",
  "social.problem.auth.title": "“আবার যুক্ত করতে হবে”",
  "social.problem.auth.body": "{platform} BrandEx-এর অ্যাক্সেস আর গ্রহণ করছে না: পাসওয়ার্ড বদলেছে, অ্যাক্সেস সরানো হয়েছে, বা মেয়াদ শেষ। আবার যুক্ত করুন; পিন ও লুকানো পোস্ট থেকে যাবে।",
  "social.problem.auth.short": "{platform} আমাদের অ্যাক্সেস আর গ্রহণ করছে না। আবার যুক্ত করুন; পিন থেকে যাবে।",
  "social.problem.not_found.title": "অ্যাকাউন্টটি পাওয়া যাচ্ছে না",
  "social.problem.not_found.body": "অ্যাকাউন্টটি মুছে ফেলা, নাম বদলানো বা BrandEx-এর সঙ্গে আর শেয়ার করা নেই। {platform}-এ দেখে আবার যুক্ত করুন।",
  "social.problem.not_found.short": "{platform} এই অ্যাকাউন্ট আর খুঁজে পাচ্ছে না। দেখে আবার যুক্ত করুন।",
  "social.problem.rate_limited.title": "“{platform} ধীরে চলতে বলেছে”",
  "social.problem.rate_limited.body": "প্ল্যাটফর্মগুলো কতবার পড়া যাবে তার সীমা রাখে। আমরা নিজে থেকেই আবার চেষ্টা করি; আপনার কিছু করার নেই।",
  "social.problem.rate_limited.short": "{platform} ধীরে চলতে বলেছে। আমরা নিজে থেকেই আবার চেষ্টা করব।",
  "social.problem.not_configured.title": "“এখনও সেট আপ হয়নি”",
  "social.problem.not_configured.body": "{platform}-এর জন্য BrandEx-এর কী নেই বা গ্রহণ করা হয়নি। BrandEx স্টাফ সার্ভারে এটি ঠিক করবেন; ততক্ষণ আপনার পোস্ট যেমন আছে তেমনই থাকবে।",
  "social.problem.not_configured.short": "BrandEx-এর {platform} কী-তে মনোযোগ দরকার। আমরা দেখছি; আপনার পোস্ট যেমন আছে থাকবে।",
  "social.problem.unavailable.title": "{platform} সাড়া দেয়নি",
  "social.problem.unavailable.body": "নেটওয়ার্কের সমস্যা বা {platform}-এ বিভ্রাট। আমরা ক্রমশ বাড়ানো বিরতিতে, অন্তত কয়েক ঘণ্টা পরপর আবার চেষ্টা করি।",
  "social.problem.unavailable.short": "{platform} সাড়া দেয়নি। আমরা চেষ্টা চালিয়ে যাব।",
  "articles.title": "প্রবন্ধ",
  "articles.subtitle": "আপনার ওয়েবসাইটের জন্য স্বাস্থ্যবিষয়ক প্রবন্ধ লিখুন। রোগীরা অ্যাপয়েন্টমেন্টের আগে এগুলো পড়েন। প্রকাশের আগে প্রতিটি লেখা আপনি অনুমোদন করেন।",
  "articles.new": "নতুন প্রবন্ধ",
  "articles.search": "প্রবন্ধ খুঁজুন",
  "articles.filter": "প্রবন্ধ ফিল্টার করুন",
  "articles.tab.all": "সব",
  "articles.tab.draft": "খসড়া",
  "articles.tab.in_review": "পর্যালোচনায়",
  "articles.tab.published": "প্রকাশিত",
  "articles.tab.unpublished": "অপ্রকাশিত",
  "articles.status.draft": "খসড়া",
  "articles.status.in_review": "পর্যালোচনায়",
  "articles.status.published": "প্রকাশিত",
  "articles.status.unpublished": "অপ্রকাশিত",
  "articles.empty": "এখনও কোনো প্রবন্ধ নেই। প্রথমটি লিখুন: এতে রোগীরা অ্যাপয়েন্টমেন্টের আগেই আপনার ওপর ভরসা পান।",
  "articles.noMatch": "কোনো প্রবন্ধ মেলেনি।",
  "articles.homeHint": "আপনার হোম পেজে {max}টি প্রবন্ধ দেখায়: প্রথমে পিন করাগুলো ({max}টির মধ্যে {pinned}টি পিন করা), তারপর সাম্প্রতিকগুলো।",
  "articles.pinned": "হোম পেজে",
  "articles.pin": "হোমে পিন করুন",
  "articles.unpin": "পিন সরান",
  "articles.pinLabel": "“{title}” হোম পেজে পিন করুন",
  "articles.unpinLabel": "“{title}” হোম পেজ থেকে পিন সরান",
  "articles.pinsFull": "{max}টি প্রবন্ধ পিন করা আছে। আগে একটির পিন সরান।",
  "articles.readingTime": "{n} মিনিটের পড়া",
  "articles.updated": "হালনাগাদ: {when}",
  "articles.back": "সব প্রবন্ধ",
  "articles.loadFailed": "প্রবন্ধটি লোড করা যায়নি।",
  "articles.field.title": "শিরোনাম",
  "articles.field.titleHint": "৫ থেকে ১২০ অক্ষর।",
  "articles.field.slug": "ওয়েব ঠিকানা",
  "articles.field.slugHint": "ইংরেজি অক্ষর, সংখ্যা ও হাইফেন। ফাঁকা রাখলে শিরোনাম থেকে তৈরি হবে।",
  "articles.field.excerpt": "সারসংক্ষেপ",
  "articles.field.excerptHint": "তালিকা ও সার্চ ফলাফলে দেখায়। প্রকাশ করতে কমপক্ষে ২০ অক্ষর ({n}/৩০০)।",
  "articles.field.language": "ভাষা",
  "articles.field.tags": "ট্যাগ",
  "articles.field.tagsHint": "সর্বোচ্চ ৫টি, কমা দিয়ে আলাদা করুন।",
  "articles.field.cover": "কভার ছবি",
  "articles.field.coverHint": "কমপক্ষে ৪০০ পিক্সেল চওড়া। PNG, JPEG বা WebP, সর্বোচ্চ ৫ এমবি।",
  "articles.cover.upload": "কভার আপলোড করুন",
  "articles.cover.replace": "কভার বদলান",
  "articles.cover.remove": "কভার সরান",
  "articles.seo": "সার্চে যেভাবে দেখাবে",
  "articles.seo.title": "সার্চ শিরোনাম",
  "articles.seo.titleHint": "সর্বোচ্চ ৭০ অক্ষর। ফাঁকা থাকলে শিরোনাম ব্যবহার হবে।",
  "articles.seo.description": "সার্চ বিবরণ",
  "articles.seo.descriptionHint": "সর্বোচ্চ ১৬০ অক্ষর। ফাঁকা থাকলে সারসংক্ষেপ ব্যবহার হবে।",
  "articles.settings": "লেখার সেটিংস",
  "articles.ready": "প্রকাশের জন্য প্রস্তুত?",
  "articles.ready.title": "স্পষ্ট শিরোনাম",
  "articles.ready.summary": "অন্তত ৫০ অক্ষরের সারাংশ",
  "articles.ready.cover": "কভার ছবি",
  "articles.ready.length": "অন্তত {n} শব্দ",
  "articles.ready.tags": "অন্তত একটি ট্যাগ",
  "articles.ready.seo": "সার্চ বিবরণ (বা সারাংশ)",
  "articles.ready.done": "সম্পন্ন",
  "articles.ready.todo": "এখনো বাকি",
  "articles.ready.words": "{n} শব্দ · প্রায় {minutes} মিনিটে পড়া যায়",
  "articles.seo.preview": "সার্চ ফলাফলের প্রিভিউ",
  "articles.untitled": "শিরোনামহীন লেখা",
  "articles.body": "প্রবন্ধের লেখা",
  "articles.bodyPlaceholder": "লেখা শুরু করুন…",
  "articles.write": "লিখুন",
  "articles.preview": "প্রিভিউ",
  "articles.previewEmpty": "প্রিভিউ করার মতো কিছু এখনও নেই।",
  "articles.saveChanges": "পরিবর্তন সংরক্ষণ করুন",
  "articles.saveDraft": "খসড়া সংরক্ষণ করুন",
  "articles.saving": "সংরক্ষণ হচ্ছে…",
  "articles.saved": "সংরক্ষিত {when}",
  "articles.unsaved": "অসংরক্ষিত পরিবর্তন",
  "articles.saveFailed": "সংরক্ষণ করা যায়নি। আপনার লেখা এখানেই আছে: আবার চেষ্টা করুন।",
  "articles.liveNote": "প্রবন্ধটি এখন প্রকাশিত। শুধু \"পরিবর্তন সংরক্ষণ করুন\" চাপলেই পরিবর্তন সংরক্ষিত হয়, তাই পাঠকরা কখনো অর্ধেক লেখা দেখেন না।",
  "articles.drafterNote": "আপনি লিখতে ও পর্যালোচনার জন্য পাঠাতে পারেন। প্রকাশ করেন শুধু ডাক্তার। প্রকাশিত প্রবন্ধ সম্পাদনা করলে ডাক্তার আবার প্রকাশ না করা পর্যন্ত সেটি খসড়ায় ফিরে যায়।",
  "articles.waitingDoctor": "ডাক্তারের পর্যালোচনা ও প্রকাশের অপেক্ষায়।",
  "articles.action.submit": "পর্যালোচনার জন্য পাঠান",
  "articles.action.publish": "প্রকাশ করুন",
  "articles.action.publishAgain": "আবার প্রকাশ করুন",
  "articles.action.unpublish": "প্রকাশ বন্ধ করুন",
  "articles.action.requestChanges": "পরিবর্তনের জন্য ফেরত পাঠান",
  "articles.action.delete": "মুছুন",
  "articles.action.deleteConfirm": "প্রবন্ধটি চিরতরে মুছে ফেলবেন?",
  "articles.action.deleteYes": "হ্যাঁ, মুছুন",
  "articles.action.keep": "রেখে দিন",
  "articles.live": "প্রকাশিত। পাঠকরা এখন এটি দেখতে পারছেন।",
  "articles.viewLive": "ওয়েবসাইটে দেখুন",
  "articles.error.slugTaken": "এই ওয়েব ঠিকানা অন্য একটি প্রবন্ধে ব্যবহৃত হচ্ছে।",
  "articles.error.titleFirst": "আগে কমপক্ষে ৫ অক্ষরের একটি শিরোনাম দিন।",
  "articles.error.upload": "ছবিটি আপলোড করা যায়নি।",
  "editor.toolbar": "ফরম্যাটিং",
  "editor.undo": "পূর্বাবস্থায়",
  "editor.redo": "আবার করুন",
  "editor.heading2": "শিরোনাম",
  "editor.heading3": "উপ-শিরোনাম",
  "editor.heading4": "ছোট শিরোনাম",
  "editor.paragraph": "অনুচ্ছেদ",
  "editor.bold": "গাঢ়",
  "editor.italic": "বাঁকা",
  "editor.underline": "আন্ডারলাইন",
  "editor.strike": "কাটা দাগ",
  "editor.code": "কোড",
  "editor.link": "লিংক",
  "editor.removeLink": "লিংক সরান",
  "editor.linkAddress": "লিংকের ঠিকানা",
  "editor.linkApply": "প্রয়োগ করুন",
  "editor.linkInvalid": "পূর্ণ ঠিকানা দিন, যেমন https://example.com",
  "editor.bulletList": "বুলেট তালিকা",
  "editor.orderedList": "ক্রমিক তালিকা",
  "editor.quote": "উদ্ধৃতি",
  "editor.codeBlock": "কোড ব্লক",
  "editor.rule": "বিভাজক",
  "editor.image": "ছবি যোগ করুন",
  "editor.imageUploading": "ছবি আপলোড হচ্ছে…",
  "editor.imageFailed": "ছবিটি আপলোড করা যায়নি।",
  "editor.imageAltPrompt": "ছবির বিবরণ",
  "editor.table": "টেবিল যোগ করুন",
  "editor.addRow": "সারি যোগ করুন",
  "editor.addColumn": "কলাম যোগ করুন",
  "editor.deleteRow": "সারি মুছুন",
  "editor.deleteColumn": "কলাম মুছুন",
  "editor.deleteTable": "টেবিল মুছুন",
  "editor.embed": "ভিডিও বা ম্যাপ যুক্ত করুন",
  "editor.embedSource": "লিংক বা এমবেড কোড",
  "editor.embedHint": "YouTube, Facebook, Instagram, TikTok, Vimeo বা Google Maps লিংক, অথবা কোনো সাইটের দেওয়া <iframe> কোড পেস্ট করুন। স্ক্রিপ্ট কখনো রাখা হয় না।",
  "editor.embedTitle": "শিরোনাম (স্ক্রিন রিডারে পড়া হয়)",
  "editor.embedAspect": "আকার",
  "editor.embedInsert": "যুক্ত করুন",
  "editor.embedCancel": "বাতিল",
  "editor.embedInvalid": "এটি যুক্ত করা যাবে না। সাইটের https:// লিংক বা <iframe> কোড দিন।",
  "editor.aspect.wide": "চওড়া (১৬:৯)",
  "editor.aspect.standard": "সাধারণ (৪:৩)",
  "editor.aspect.square": "বর্গাকার",
  "editor.aspect.tall": "লম্বা (৯:১৬)",
  "editor.aspect.portrait": "পোর্ট্রেট (৩:৪)",
  "editor.words": "শব্দ: {n}",
  "editor.content": "প্রবন্ধের লেখা",
  "analytics.title": "ওয়েবসাইট ভিজিটর",
  "analytics.subtitle": "কতজন আপনার ওয়েবসাইটে আসেন এবং বুকিং বোতাম চাপেন। সাইটের প্রতিটি পেজে গোনা হয়।",
  "analytics.range": "তারিখের সীমা",
  "analytics.range.7": "৭ দিন",
  "analytics.range.30": "৩০ দিন",
  "analytics.range.90": "৯০ দিন",
  "analytics.range.365": "১২ মাস",
  "analytics.range.custom": "নিজে বাছুন",
  "analytics.from": "শুরু",
  "analytics.to": "শেষ",
  "analytics.apply": "দেখুন",
  "analytics.badRange": "শুরুর তারিখ শেষের আগে বা একই দিনে দিন, সর্বোচ্চ ৪০০ দিনের ব্যবধানে।",
  "analytics.showing": "{from} থেকে {to}, বাংলাদেশ সময়",
  "analytics.visits": "ভিজিট",
  "analytics.visitsHint": "আপনার সাইটে খোলা পেজ",
  "analytics.visitors": "ভিজিটর",
  "analytics.visitorsHint": "ভিন্ন ভিন্ন মানুষ (ডিভাইস ও নেটওয়ার্ক)",
  "analytics.clicks": "বুকিং ক্লিক",
  "analytics.clicksHint": "কল, হোয়াটসঅ্যাপ, ক্যালেন্ডলি বা বুকিং ফর্মে চাপ",
  "analytics.bookers": "সম্ভাব্য বুকিং",
  "analytics.bookersHint": "যে ভিজিটররা বুকিং বোতাম ব্যবহার করেছেন",
  "analytics.bookersRate": "{rate}% ভিজিটর বুকিং বোতাম ব্যবহার করেছেন",
  "analytics.daily": "দিনভিত্তিক ভিজিট",
  "analytics.dailyHint": "প্রতিদিনের সংখ্যা দেখতে বারের ওপর মাউস রাখুন বা ট্যাব চাপুন।",
  "analytics.empty": "এই সময়ে এখনও কোনো ভিজিট নেই।",
  "analytics.table": "টেবিল আকারে দেখুন",
  "analytics.day": "দিন",
  "analytics.max": "সবচেয়ে ব্যস্ত দিন: {n}",
  "analytics.tip": "{visits} ভিজিট, {visitors} ভিজিটর, {clicks} বুকিং ক্লিক",
  "analytics.channels": "ব্যবহৃত বুকিং বোতাম",
  "analytics.channel.call": "কল",
  "analytics.channel.whatsapp": "হোয়াটসঅ্যাপ",
  "analytics.channel.calendly": "ক্যালেন্ডলি",
  "analytics.channel.form": "বুকিং ফর্ম",
  "analytics.noClicks": "এই সময়ে কোনো বুকিং ক্লিক নেই।",
  "analytics.sources": "ভিজিটররা কোথা থেকে এসেছেন",
  "analytics.direct": "সরাসরি, অ্যাপ বা অজানা",
  "analytics.noVisits": "এই সময়ে কোনো ভিজিট নেই।",
  "analytics.devices": "ডিভাইস",
  "analytics.device.mobile": "মোবাইল",
  "analytics.device.tablet": "ট্যাবলেট",
  "analytics.device.desktop": "কম্পিউটার",
  "analytics.pages": "সবচেয়ে বেশি দেখা পেজ",
  "analytics.approximate": "বুকিং ক্লিক একটি আনুমানিক হিসাব: কেউ বোতাম চেপেও ফোন না করতে পারেন, আবার সাইটে না এসেও ফোনে বুক করতে পারেন। সার্চ ইঞ্জিন ও লিংক প্রিভিউ গোনা হয় না।",
  "analytics.privacy": "রোগীর গোপনীয়তা: কোনো কুকি ব্যবহার হয় না এবং পূর্ণ আইপি ঠিকানা কখনো সংরক্ষণ হয় না, শুধু নেটওয়ার্কের অংশ। তথ্য প্রায় ১৩ মাস রাখা হয়।",
};
